import React, { useState, useEffect, useCallback } from 'react';
import { Typography, Button, Paper, Box, TextField, IconButton, Snackbar, Alert, Dialog, DialogTitle, DialogContent, FormControl, InputLabel, Select, Menu, MenuItem, Tooltip, Stack, Drawer, Divider, Chip } from '@mui/material';
import { Tooltip as MuiTooltip } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { myApi } from '../../config/axiosConfig';
import useMediaQuery from '@mui/material/useMediaQuery';
import Swal from 'sweetalert2';
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useRef } from "react";
import Draggable from 'react-draggable';
import img from "../../assets/img/spinner.svg";
import { makeStyles } from '@mui/styles';
import BtnAcciones from '../../components/plantilla/tabla/BtnAcciones';
import { base_url, base_url_clean } from '../../config/urls';
// Iconos
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ImageIcon from '@mui/icons-material/Image';
import BorderColorIcon from '@mui/icons-material/BorderColor';
// Iconos
import ClearIcon from '@mui/icons-material/Clear';

import { AgGridReact } from 'ag-grid-react';
import { AllCommunityModule } from 'ag-grid-community';

import CollectionsIcon from '@mui/icons-material/Collections';
import GalleryDialog from './modales/GalleryDialog';
import ColorLegendDialog from './modales/ColorLegendDialog';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import DeleteIcon from '@mui/icons-material/Delete';
import TuneIcon from '@mui/icons-material/Tune';
import AddIcon from '@mui/icons-material/Add';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import Cookies from 'js-cookie';

import CrearEditarModal from './modales/CrearEditarReset';
import SubirModal from './modales/SubirModal3';

import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { useNavigate } from 'react-router-dom';

function PaperComponent(props) {
    const nodeRef = React.useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        handle="#draggable-dialog-title"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
}

const Master_Dashboard = ({ tipoActual = 'CAJAS' }) => {
    const gridRef = useRef();

    const [anchorEl, setAnchorEl] = useState(null);
    const open2 = Boolean(anchorEl);
    const navigate = useNavigate();

    const [selectedRow, setSelectedRow] = useState(null);
    const [rankingAssets, setRankingAssets] = useState(null);
    const [rankingDrivers, setRankingDrivers] = useState(null);

    const [selected, setSelected] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [isEditing, setIsEditing] = useState(false);

    const [openGallery, setOpenGallery] = useState(false);
    
        const handleCloseGallery = () => 
        {
            setOpenGallery(false);
            setSelectedRow(null);
        };

        /*=============================================
        Funcion que renderiza el dialogo de galeria
        =============================================*/
        const renderizarDialogGaleria = (row) => 
        {
            let rutas = [];
    
            try {
                rutas = typeof row.fotos === 'string'
                    ? JSON.parse(row.fotos)
                    : row.fotos;
            } catch (e) {
                console.warn("No se pudo convertir rutas_fotos a array:", e);
                rutas = [];
            }
    
            if (!Array.isArray(rutas)) {
                rutas = [rutas];
            }
    
            const rutasValidas = rutas.filter(f =>
                f &&
                typeof f === 'object' &&
                typeof f.ruta === 'string' &&
                f.ruta.trim() !== ''
            );
    
            if (rutasValidas.length === 0) {
                Swal.fire("Sin imágenes", "Esta unidad no tiene imágenes disponibles.", "info");
                return;
            }
    
            setSelectedRow({
                ...row,
                rutas_fotos: rutasValidas
            });
            setOpenGallery(true);
        }; 

    const useStyles = makeStyles({
        cellLightRed: {
            backgroundColor: "#EA9999 !important",
            fontWeight: "bold",
            color: "#000"
        },
        cellGreen: {
            backgroundColor: "#D9EAD3 !important",
            fontWeight: "bold",
            color: "#000"
        },
        rowBlue: {
            backgroundColor: "#4A86E8 !important",
            color: "white",
        },
        cellBlack: {
            backgroundColor: "#000 !important",
            color: "#fff",
            fontWeight: "bold"
        },
        cellBrightGreen: {
            backgroundColor: "#00ff00 !important",
            color: "#000",
            fontWeight: "bold"
        },
        cellGreenMedium: {
            backgroundColor: "#B6D7A8 !important",
            color: "#000",
            fontWeight: "bold"
        },
        cellYellow: {
            backgroundColor: "#FFE599 !important",
            color: "#000",
            fontWeight: "bold"
        },
        cellRed: {
            backgroundColor: "#ff0000 !important",
            color: "#fff",
            fontWeight: "bold"
        },
        cellPurple: {
            backgroundColor: "#9c27b0 !important",
            color: "#fff",
            fontWeight: "bold"
        },
        locationLaredo: {
            backgroundColor: "#073763 !important", 
            color: "#fff",
            fontWeight: "bold"
        },
        locationColombia: {
            backgroundColor: "#fff2cc !important",
            color: "#000",
            fontWeight: "bold"
        },
        cellDarkRed: {
            backgroundColor: "#8B0000 !important", 
            color: "#fff",
            fontWeight: "bold"
        },
        cellDiferencia: {
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            boxSizing: "border-box"
        }
    });

    const classes = useStyles();

    const [data, setData] = useState([]);

    const [loading, setLoading] = useState(false);

    const [unit, setUnit] = useState(''); // Estado para el campo "Unidad"
    const [type, setType] = useState("TODO"); // Estado para el campo "Tipo tractor/caja"
    const [typeOf, setTypeOf] = useState("TODO"); // Estado para el campo "Tipo tractor/caja"
    const [sorted, setSorted] = useState("FECHA"); // Estado para el sorted
    const [colorGPH, setColorGPH] = useState("TODO"); // Estado para el campo "Color Tolerancia"
    const [company, setCompany] = useState("TODAS"); // Estado para el campo "Color Tolerancia"
    const [startDate, setStartDate] = useState(null); // Estado para la fecha inicial
    const [endDate, setEndDate] = useState(null); // Estado para la fecha final

    // Maneja los cambios en el campo "Unidad"
    const handleChangeUnidad = (event) => {
        setUnit(event.target.value);
    };

    // Maneja los cambios en el campo "Tipo"
    const handleChangeTipo = (event) => {
        setType(event.target.value);
    };
    // Maneja los cambios en el campo "Tipo De"
    const handleChangeTipoDe = (event) => {
        setTypeOf(event.target.value);
    };
    // Maneja los cambios en el campo "Company"
    const handleChangeCompany = (event) => {
        setCompany(event.target.value);
    };
    // Maneja los cambios en el campo "Sorted"
    const handleChangeSorteado = (event) => {
        const value = event.target.value;
        setSorted(value);
        if (value === 'TRACTORYFECHA') 
        {
            setType('TRACTOR');
        } 
        else if (value === 'FECHA') 
        {
            setType('TODO');
        }
    };
    // Maneja los cambios en el campo "color tolerancia"
    const handleChangeColorGPH = (event) => {
        setColorGPH(event.target.value);
    };

    // Maneja los cambios en la fecha de inicio
    const handleChangeStartDate = (newValue) => {
        setStartDate(newValue);
        // Si la fecha final ya está establecida y es menor a la fecha inicial, la actualizamos
        if (endDate && newValue.isAfter(endDate)) {
            Swal.fire({
                icon: 'error',
                title: 'La fecha inicial no puede ser mayor que la fecha inicial.',
            }).then(() => {
                setEndDate(newValue);
            }); 
                // Establecer la fecha final igual a la fecha inicial
        }
    };

    // Maneja los cambios en la fecha de fin
    const handleChangeEndDate = (newValue) => {
        setEndDate(newValue);
        if (startDate && newValue.isBefore(startDate)) {
            Swal.fire({
                icon: 'error',
                title: 'La fecha final no puede ser menor que la fecha inicial.',
            }).then(() => {
                setEndDate(startDate);
            }); 
        }
    };

    // Handler para vaciar la fecha al hacer clic
    const handleClearDate = (fecha) => {
        if(fecha === 'fi')
            setStartDate(null); 
        else if (fecha === 'ff')
            setEndDate(null); 
    };



    //Función para formatear la fecha
    const formatDate = (date) => {
        if (!date) return ""; 

        const d = new Date(date);
        if (isNaN(d)) return "";

        const options = {
            year: '2-digit', // Año con dos dígitos
            month: '2-digit', // Mes con dos dígitos
            day: '2-digit', // Día con dos dígitos
            hour: '2-digit', // Hora con dos dígitos
            minute: '2-digit', // Minutos con dos dígitos
            second: '2-digit',    // Segundos con dos dígitos
            hour12: false, // Formato de 24 horas
        };
    
        const formattedDate = new Date(date).toLocaleString('en-US', options);
    
        // Formato deseado: MM/DD/YY HH:mm
        const [datePart, timePart] = formattedDate.split(', '); // Separar fecha y hora
        const [month, day, year] = datePart.split('/'); // Separar mes, día y año
        //const formattedDateTime = `${month}/${day}/${year} ${timePart.slice(0, 5)}`; // Construir el formato
        const formattedDateTime = `${month}/${day}/${year} ${timePart}`; // Construir el formato
    
        return formattedDateTime;
    };

    const formatTime = (value) => 
    {
        if (!value) return '';

        const pad = (n) => n.toString().padStart(2, '0');

        // Si ya viene como HH:mm o HH:mm:ss
        if (typeof value === 'string' && value.includes(':')) {
            const parts = value.split(':');
            let hours = '00', minutes = '00', seconds = '00';

            if (parts.length === 3) {
                [hours, minutes, seconds] = parts;
            } else if (parts.length === 2) {
                [hours, minutes] = parts;
            }

            return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
        }

        // Si viene como número decimal (horas)
        const totalHours = parseFloat(value);
        if (isNaN(totalHours)) return '';

        let hours = Math.floor(totalHours);
        let minutes = Math.floor((totalHours - hours) * 60);
        let seconds = Math.round(((totalHours - hours) * 60 - minutes) * 60);

        if (seconds === 60) {
            seconds = 0;
            minutes += 1;
        }
        if (minutes === 60) {
            minutes = 0;
            hours += 1;
        }

        return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    };

    const [snackbarOpen, setSnackbarOpen] = useState(false);
    
    const handleOpenSnackbar = () => setSnackbarOpen(true);
    const handleCloseSnackbar = (event, reason) => {
      if (reason === 'clickaway') return;
      setSnackbarOpen(false);
    };

    const [open, setOpen] = useState(false);
    const [fileUrl, setFileUrl] = useState('');
    const [isPdf, setIsPdf] = useState(false);
    const [isImage, setIsImage] = useState(false);
    const [Titulo, setTitulo] = useState('');

    const handleFileClick = (fileName) => 
    {
        //console.log(encodeURIComponent(fileName))
        const extension = fileName.split('.').pop().toLowerCase();
        const isPdfFile = extension === 'pdf';
        const isImageFile = ['jpg', 'jpeg', 'png', 'gif'].includes(extension);

        const mimeType = isPdfFile ? 'application/pdf' : isImageFile ? `image/${extension === 'jpg' ? 'jpeg' : extension}` : '';

        myApi.get(`fuel_report/pdf/${encodeURIComponent(fileName)}`, { responseType: 'arraybuffer' })
        .then((response) => {
            const blob = new Blob([response.data], { type: mimeType });
            //console.log(blob)
            const url = window.URL.createObjectURL(blob);
            //window.open(url);
            //console.log(url)
            //setPdfFile(url);
            setIsPdf(isPdfFile);
            setIsImage(isImageFile);
            setFileUrl(url);
            setOpen(true);
        })
        .catch((error) => {
            console.error('Error al cargar el PDF:', error);
        });
    };

    const handleImageClick = async (rel_fuel_up, nombre_col, numero) => 
    {
        try 
        {
            const flujoResponse = await myApi.get(`/fuel_report/getFlujoFromColumn/${rel_fuel_up}/${nombre_col}`);

            const rel_flujo = flujoResponse.data?.data?.[0]?.rel_flujo;

            if (!rel_flujo) 
            {
                throw new Error('No se encontró rel_flujo para esa columna');
            }

            const response = await myApi.get(`/fuel_up/getPhoto/${rel_fuel_up}/${rel_flujo}`);

            const fotosEnumeradas = response.data.data
            .sort((a, b) => a.id - b.id)
            .map((foto, index) => ({
                ...foto,
                numero: index + 1
            }));

            //console.log(fotosEnumeradas);

            let url;
            if (fotosEnumeradas.length === 1) {
                // Solo una foto
                const numero = fotosEnumeradas[0].numero;
                //console.log("Solo una foto. Número:", numero);
                url = `${base_url_clean}/docs_fuel_up${response.data.data[0].ruta}`;
            } else if (fotosEnumeradas.length > 1) {
                // Varias fotos
                const numeros = fotosEnumeradas.map(f => f.numero);
                //console.log("Varias fotos. Números:", numeros);
                url = `${base_url_clean}/docs_fuel_up${response.data.data[numero - 1].ruta}`;
            } else {
                console.log("No hay fotos.");
                url = ``;
            }

            //const url = `${base_url_clean}/docs_fuel_up${response.data.data[0].ruta}`;

            //console.log(url)

            setIsImage(true);
            setFileUrl(url);  
            setOpen(true);   
        }
        catch(error) 
        {
            console.error('Error al cargar la imagen:', error);
        }
    };

    const handleOpenDialog = (params, isPdf = 1, nombre_col = '', titulo = '', numero = null) => 
    {
        setTitulo(titulo);
        if(isPdf)
        {
            if(numero === 2)
                handleFileClick(params.pdf);
            else
                handleFileClick(params.pc_file);
        }
        else
            handleImageClick(params.id, nombre_col, numero);
    };
    const handleCloseDialog = () => 
    {
        setOpen(false);
    };

    const parseNumber = (value) => 
    {
        if (value === null || value === undefined || value === '') return null;
        if (value === '-') return '-';
        const num = Number(value.toString().replace(/,/g, ''));
        return isNaN(num) ? null : num;
    };

    const getOdometerDiff = (params) => 
    {
        const truck = parseNumber(params.data?.truck_odometer);
        const pc = parseNumber(params.data?.pc_truck_odometer);

        if (truck === null || pc === null) return null;
        return Math.abs(truck - pc);
    };

    const odometerTooltip = (params) => 
    {
        const diff = getOdometerDiff(params);
        if (diff === null) return '';

        return `Diferencia: ${diff.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })} mi`;
    };

    const lastModTooltip = (params) => 
    {
        if (!params.data) return '';

        const usuario = params.data.ultimo_usuario || 'SIN USUARIO';
        const fecha = params.data.ultima_fecha 
            ? new Date(params.data.ultima_fecha).toLocaleString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            }) 
            : 'SIN FECHA';

        return `Usuario: ${usuario} Fecha: ${fecha}`;
        return `Última modificación:<br>Usuario: ${usuario}<br>Fecha: ${fecha}`;
    };

    const getDistanceDiff = (params) => 
    {
        const odo = parseNumber(params.data?.DistanciaOdo);
        const pc = parseNumber(params.data?.pc_distance);

        if (odo === null || pc === null) return null;
        return Math.abs(odo - pc);
    };

    const distanceTooltip = (params) => 
    {
        const diff = getDistanceDiff(params);
        if (diff === null) return '';

        return `Diferencia: ${diff.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })} mi`;
    };

    const normalizarFotosGrid = (fotos) => {
    if (!fotos) return [];

    let parsed = fotos;

    if (typeof fotos === 'string') {
        try {
            parsed = JSON.parse(fotos);
        } catch {
            return [];
        }
    }

    if (!Array.isArray(parsed)) {
        parsed = [parsed];
    }

    return parsed.filter(f =>
        f &&
        typeof f === 'object' &&
        typeof f.ruta === 'string' &&
        f.ruta.trim() !== ''
    );
};

const getFormattedRowString = (rowData, columns) => {
  const fieldsToCopy = columns.filter(
    col => col.field && col.field !== "copy" && col.field !== "actions" && col.field !== "fotos" && col.field !== "pc_file"
  );

  const formattedValues = fieldsToCopy.map(col => {
    // Si hay valueFormatter, lo usamos
    if (col.valueFormatter) {
      return col.valueFormatter({
        value: rowData[col.field],
        data: rowData,
      });
    }

    // Valor plano
    return rowData[col.field] ?? "";
  });

  return formattedValues.join("\t"); // Excel friendly
};

    const PdfUploadRenderer = ({ data, node }) => 
    {
        const inputRef = React.useRef();

        const handleUpload = async (e) => 
        {
            const file = e.target.files[0];
            
            if(!file) 
            {
                Swal.fire({
                    icon: 'error',
                    title: '¡Seleccione un archivo!'
                });
                return;
            }

            if (file.type !== 'application/pdf') 
            {
                Swal.fire({
                    icon: 'error',
                    title: 'Solo se permite PDF'
                });
                return;
            }

            const formData = new FormData();
            formData.append('file', file);
            formData.append('usuario', Cookies.get('ebt_nombre'));

            Swal.fire({
                icon: 'info',
                title: 'Cargando...',
                allowOutsideClick: false,
                showConfirmButton: false
            });

            try 
            {
                const res = await myApi.put(`/cargasFuel/updateMasterDash2/subirPDF/${data.id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });

                if (res.data.success) 
                {
                    Swal.fire({ 
                        icon: 'success',
                        title: '¡PDF Subido!' 
                    });
                    node.setDataValue('pdf', res.data.data.pdf);
                } 
                else 
                {
                    Swal.fire({ 
                        icon: 'error', 
                        title: res.data.data || 'Error al subir PDF'
                    });
                }
            } 
            catch (error) 
            {
                console.error(error);
                Swal.fire({ 
                    icon: 'error', 
                    title: '¡Ocurrió un error!' 
                });
            } 
            finally 
            {
                e.target.value = null;
            }
        };

        const handleDelete = async () => 
        {
            const confirm = await Swal.fire({
                icon: 'warning',
                title: '¿Eliminar PDF?',
                text: 'Esta acción no se puede deshacer',
                showCancelButton: true,
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar'
            });

            if (!confirm.isConfirmed) return;

            const formData = new FormData();
            formData.append('pdfEliminar', '1');
            formData.append('usuario', Cookies.get('ebt_nombre'));

            try 
            {
                const res = await myApi.put(`/cargasFuel/updateMasterDash2/subirPDF/${data.id}`, formData);

                if (res.data.success) 
                {
                    Swal.fire({ 
                        icon: 'success', 
                        title: 'PDF eliminado' 
                    });
                    node.setDataValue('pdf', res.data.data.pdf);
                } 
                else 
                {
                    Swal.fire({ 
                        icon: 'error', 
                        title: res.data.data || 'No se pudo eliminar' 
                    });
                }
            } 
            catch (error) 
            {
                console.error(error);
                Swal.fire({ 
                    icon: 'error', 
                    title: '¡Ocurrió un error!' 
                });
            }
        };

        if (data.pdf) 
        {
            return (
                <Stack direction="row" spacing={0.5} justifyContent="center">
                    <Tooltip title="Ver PDF">
                        <IconButton
                            size="small"
                            color="primary"
                            onClick={() => handleOpenDialog(data, 1, null, 'PDF SUBIDO', 2)}
                        >
                            <PictureAsPdfIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Eliminar PDF">
                        <IconButton
                            size="small"
                            color="error"
                            onClick={handleDelete}
                        >
                            <DeleteIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </Stack>
            );
        }

       return (
            <>
            <input
                ref={inputRef}
                type="file"
                accept="application/pdf"
                hidden
                onChange={handleUpload}
            />
            <Stack direction="row" spacing={0.5} justifyContent="center">
                <Tooltip title="Subir PDF">
                    <IconButton
                    size="small"
                    color="primary"
                    onClick={() => inputRef.current.click()}
                    >
                    <UploadFileIcon />
                    </IconButton>
                </Tooltip>
            </Stack>
            </>
        );
    };

    const DbCheckboxRenderer = ({ data, colDef, node }) => 
    {
        const [checked, setChecked] = React.useState(data[colDef.field] === '1');

        const handleChange = async (e) => 
        {
            const newValue = e.target.checked;
            setChecked(newValue);

            try 
            {
                const res = await myApi.put(
                    `/cargasFuel/updateMasterDash2/updateCheck/${data.id}`,
                    {
                        field: colDef.field,
                        value: newValue,
                        usuario: Cookies.get('ebt_nombre')
                    }
                );
                if (res.data.success) 
                {
                    Swal.fire({ 
                        icon: 'success', 
                        title: 'Validación actualizada' 
                    });
                    node.setDataValue(colDef.field, res.data.data[colDef.field]);
                } 
                else 
                {
                    Swal.fire({ 
                        icon: 'error', 
                        title: res.data.data || 'No se pudo actualizar' 
                    });
                }
            } 
            catch (err) 
            {
                setChecked(!newValue); 
                Swal.fire({
                    icon: 'error',
                    title: 'Error al actualizar'
                });
            }
        };

        return (
            <input
                type="checkbox"
                checked={checked}
                onChange={handleChange}
            />
        );
    };

    const handleDeleteFile = useCallback(async (params, tipoArchivo = 1) => 
        {
            const esPdf = tipoArchivo === 1;
            const tipoTexto = esPdf ? "el PDF" : "la imagen";
            const textoSinArticulo = tipoTexto.replace(/^(el|la)\s+/i, '');
            try 
            {
                Swal.fire({
                    title: `¿Está seguro de eliminar ${tipoTexto}?`,
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: '¡Sí, eliminar!',
                    cancelButtonText: 'Cancelar',
                    confirmButtonColor: 'green',
                    cancelButtonColor: 'red',
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        const id = params.id;
                        const usuario = Cookies.get('ebt_nombre');
                        let { data } = await myApi.post(`/fuel_report/eliminarRegistro3/${id}`, { usuario } );
    
                        if (data.success) {
                            Swal.fire({
                                icon: 'success',
                                title: `${textoSinArticulo.charAt(0).toUpperCase() + textoSinArticulo.slice(1)} eliminad${esPdf ? 'o' : 'a'}`,
                            });
                            setData(prev =>
                                prev.map(row =>
                                    row.id === data.data.id
                                        ? { ...row, ...data.data }
                                        : row
                                )
                            );
                        } else {
                            Swal.fire({
                                icon: 'error',
                                title: `Error al eliminar ${tipoTexto}`,
                            });
                        }
                    }
                });
                
            } catch (error) {
                console.error(`Error eliminando ${tipoTexto}:`, error);
            }
        }, [data]);

    const [pdfModalOpen, setPdfModalOpen] = useState(false);

    const handleOpenModalFile = (modal, rowData = null) => 
    {
        if(modal === 'PDF')
        {
            setSelectedRow(rowData);
            setPdfModalOpen(true);
        }
    };

    const checkColumn = (header, field) => ({
        headerName: header,
        headerTooltip: header,
        field: field,
        cellRenderer: DbCheckboxRenderer,
        width: 90,
        cellStyle: {
            display: 'flex',
            justifyContent: 'center'
        }
    });

    /*
    const CheckHeaderWithStats = (props) => 
    {
        const { api, column } = props;
        const field = column.getColDef().field;
        const headerName = column.getColDef().headerName;

        const [stats, setStats] = React.useState({ count: 0, total: 0 });

        const calcular = () => {
            let count = 0;
            let total = 0;

            api.forEachNodeAfterFilterAndSort((node) => {
                if (!node.data) return;
                total++;
                if (node.data[field] === '1') count++;
            });

            setStats({ count, total });
        };

        React.useEffect(() => {
            calcular();
            api.addEventListener('cellValueChanged', calcular);
            api.addEventListener('filterChanged', calcular);
            return () => {
                api.removeEventListener('cellValueChanged', calcular);
                api.removeEventListener('filterChanged', calcular);
            };
        }, []);

        const percent = stats.total
        ? Math.round((stats.count / stats.total) * 100)
        : 0;

        const color =
        percent === 0 ? '#d32f2f' :
        percent < 50 ? '#f9a825' :
        '#2e7d32';

        const onSortClicked = () => 
        {
            const currentSort = column.getSort();

            const nextSort =
                !currentSort ? 'asc' :
                currentSort === 'asc' ? 'desc' :
                null;

            api.applyColumnState({
                state: [{
                    colId: column.getColId(),
                    sort: nextSort
                }],
                defaultState: { sort: null }
            });
        };

        return (
            <div
                onClick={onSortClicked}
                style={{
                    textAlign: 'center',
                    width: '100%',
                    cursor: 'pointer',
                    userSelect: 'none'
                }}
            >
                <div style={{ textAlign: 'center', width: '100%' }}>
                    <div style={{ fontWeight: 600 }}>
                        {headerName} ({stats.count})
                    </div>
                    <div style={{ fontSize: 11, color }}>
                        {percent}%
                    </div>
                </div>
            </div>
        );
    };

    const checkColumn = (header, field) => ({
        headerName: header,
        headerTooltip: header,
        field,
        sortable: true,
        valueGetter: params => params.data?.[field] === '1' ? 1 : 0,
        comparator: (a, b) => a - b,
        cellRenderer: DbCheckboxRenderer,
        headerComponent: CheckHeaderWithStats,
        width: 100,
        cellStyle: {
            display: 'flex',
            justifyContent: 'center'
        }
    });*/
/*
    const columns = [*/
/*         {
            field: "copy",
            headerName: "",
            width: 10,
            disableColumnMenu: true,
            disableExport: true,
            sortable: false,
            filterable: false,
            hideable: false,
            renderCell: (params) => {
                const handleCopy = () => {
                    const rowString = getFormattedRowString(params); 
                    navigator.clipboard.writeText(rowString).then(() => {
                    handleOpenSnackbar(); 
                    });
                };

                return (
                    <MuiTooltip title="Copiar renglón">
                        <IconButton onClick={handleCopy} color="primary">
                            <ContentCopyIcon />
                        </IconButton>
                    </MuiTooltip>
                );
            },
        }, *//*
        {
            headerName: "",
            field: "copy",
            pinned: true,
            sortable: false,
            filter: false,
            suppressMenu: true,
            suppressColumnsToolPanel: true,
            cellRenderer: (params) => {
                const handleCopy = (e) => {
                const rowString = getFormattedRowString(params.data, columns);
                navigator.clipboard.writeText(rowString).then(() => {
                    handleOpenSnackbar();
                });
                };

                return (
                <MuiTooltip title="Copiar renglón">
                    <IconButton onClick={handleCopy} color="primary" size="small">
                    <ContentCopyIcon fontSize="small" />
                    </IconButton>
                </MuiTooltip>
                );
            },
        },
        {
            field: "fotos",
            headerName: "IMÁGENES",
            headerTooltip: "IMÁGENES",
            suppressCsvExport: true,
            //sortable: false,
            filter: false,
            tooltipValueGetter: lastModTooltip,
            tooltipComponentParams: { className: 'custom-tooltip' },
            cellRenderer: (params) => {
                const fotosValidas = normalizarFotosGrid(params.data?.fotos);

                if (fotosValidas.length === 0) return null;

                return (
                    <BtnAcciones
                        icon={<CollectionsIcon />}
                        label={`Ver (${fotosValidas.length})`}
                        onClick={() =>
                            renderizarDialogGaleria({
                                ...params.data,
                                fotos: fotosValidas
                            })
                        }
                    />
                );
            }
        },
        { field: 'date', headerName: 'FECHA', headerTooltip: "FECHA",
            cellStyle: { textAlign: "center" },
            valueFormatter: (params) => formatDate(params.value),
            pinned: true,
            tooltipValueGetter: lastModTooltip,
        },
        { field: 'asset', headerName: 'UNIDAD',headerTooltip: "UNIDAD",
            cellStyle: { textAlign: "center" },
            pinned: true,
            cellClassRules: {
                [classes.cellDarkRed]: (params) => params.data?.asset_type === 'USA'
            },
            tooltipValueGetter: lastModTooltip,
        },
        {
            headerName: "COMPROBANTE",headerTooltip: "COMPROBANTE",
            field: "pc_file",
            //sortable: false,
            filter: false,
            suppressMenu: true,
            suppressColumnsToolPanel: true,
            suppressCsvExport: true,
            cellStyle: { textAlign: "center" },
            tooltipValueGetter: lastModTooltip,
            cellRenderer: (params) => {
                const row = params.data;

                if (row.isTotal) return null;
                if (row.asset_type === 'CAJA') return null;

                const getFileExtension = (filename) => filename?.split('.').pop().toLowerCase();

                const fileName = row.pc_file;

                //const validFileName = /^\d+_\d+\.(pdf|jpg|jpeg|png|webp)$/i.test(fileName);
                const validFileName = /^[a-zA-Z0-9]+_\d+\.(pdf|jpg|jpeg|png|webp)$/i.test(fileName);

                //if (row.pc_file && row.pc_file !== '') 
                if(fileName && validFileName)
                {
                    const ext = getFileExtension(row.pc_file);
                    const isPdf = ext === 'pdf';
                    const isImage = ['jpg', 'jpeg', 'png', 'gif'].includes(ext);

                    return (
                        <Box>
                            <BtnAcciones
                                icon={isPdf ? <PictureAsPdfIcon /> : <ImageIcon />}
                                label={isPdf ? ' Abrir PDF' : ' Abrir imagen'}
                                onClick={() => handleOpenDialog(row, 1, null, isPdf ? 'PDF SUBIDO DE PC' : 'IMAGEN SUBIDA')}
                            />
                        </Box>
                    );
                } 
            }
        },
        { 
            field: 'truck_odometer', headerName: 'TRUCK ODÓMETRO',headerTooltip: "TRUCK ODÓMETRO",
            minWidth: 120,
            cellStyle: { textAlign: "center" },
            valueGetter: (params) => {
                if (!params.data?.truck_odometer) return null;
                return Number(params.data.truck_odometer.toString().replace(/,/g, ''));
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            tooltipValueGetter: lastModTooltip,

            cellClassRules: {
                [classes.cellLightRed]: (params) => {
                if (params.data?.DistanciaOdo === 'INICIAL') return false;
                const diff = getOdometerDiff(params);
                return diff !== null && diff > 100;
                },
                [classes.cellGreen]: (params) => {
                if (params.data?.DistanciaOdo === 'INICIAL') return false;
                const diff = getOdometerDiff(params);
                return diff !== null && diff <= 100;
                },
                [classes.cellDarkRed]: (params) => {
                if (params.data?.DistanciaOdo === 'INICIAL') return false;
                return params.data?.asset_type === 'USA'
                }
            }
        },
        { field: 'DistanciaOdo', headerName: 'DISTANCIA (BASED ON LAST ODO)',headerTooltip: "DISTANCIA (BASED ON LAST ODO)",
            minWidth: 100,
            cellStyle: { textAlign: "center" },
            comparator: (a, b) => 
            {
                const esInicial = (v) => v === 'INICIAL';
                const esNull = (v) => v == null;

                if (esInicial(a) && esInicial(b)) return 0;
                if (esInicial(a)) return -1;
                if (esInicial(b)) return 1;

                if (esNull(a) && esNull(b)) return 0;
                if (esNull(a)) return 1;
                if (esNull(b)) return -1;

                return Number(a) - Number(b);
            },
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            tooltipValueGetter: lastModTooltip,

            cellClassRules: 
            {
                [classes.cellLightRed]: (params) => {
                const diff = getDistanceDiff(params);
                return diff !== null && diff > 1;
                },
                [classes.cellGreen]: (params) => {
                const diff = getDistanceDiff(params);
                return diff !== null && diff <= 1;
                }
            }
        },
        { field: 'pc_truck_odometer', headerName: 'TRUCK ODOMETRO (PC)',headerTooltip: "TRUCK ODOMETRO (PC)",
            minWidth: 120,
            cellStyle: { textAlign: "center" },
            tooltipValueGetter: lastModTooltip,
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            valueGetter: (params) => {
                if (!params.data?.pc_truck_odometer) return null;
                return Number(params.data.pc_truck_odometer.toString().replace(/,/g, ''));
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },

            cellClassRules: {
                [classes.cellLightRed]: (params) => {
                if (params.data?.DistanciaOdo === 'INICIAL') return false;
                const diff = getOdometerDiff(params);
                return diff !== null && diff > 100;
                },
                [classes.cellGreen]: (params) => {
                if (params.data?.DistanciaOdo === 'INICIAL') return false;
                const diff = getOdometerDiff(params);
                return diff !== null && diff <= 100;
                }
            }
        },
        
        { field: 'MpgReal', headerName: 'MPG REAL',headerTooltip: "MPG REAL",
            minWidth: 100,
            cellStyle: { textAlign: "center" },
            valueGetter: (params) => {
                const value = params.data.MpgReal;
                if (value === null || value === undefined || value === '' || value === '-') return null;
                const numericValue = Number(value.toString().replace(/,/g, ''));
                return isNaN(numericValue) ? null : numericValue;
            },
            valueFormatter: (params) => {
                const value = params.value;
                const row = params.data;
                if (value === null || value === undefined || value === '') 
                    return ''; 
                if (value === '-') 
                    return value; 
                const numericValue = Number(value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return value; 

                let formatted = numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

                const file = row.pc_file;
                const getFileExtension = (filename) => filename?.split('.').pop().toLowerCase();
                const ext = getFileExtension(file);
                const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext);

                if (!file || isImage) {
                    formatted += ' *';
                }

                return formatted;
            },
            cellClassRules: 
            {
                [classes.cellBlack]: (params) => parseNumber(params.value) === 0,
                [classes.cellBrightGreen]: (params) => parseNumber(params.value) >= 7,
                [classes.cellGreenMedium]: (params) => parseNumber(params.value) >= 6 && parseNumber(params.value) < 7,
                [classes.cellYellow]: (params) => parseNumber(params.value) >= 4 && parseNumber(params.value) < 6,
                [classes.cellRed]: (params) => {
                    const val = parseNumber(params.value);
                    return val !== null && val > 0 && val < 4;
                }
            },
            tooltipValueGetter: lastModTooltip,
        },
        { field: 'pc_mpg', headerName: 'MPG (PC)',headerTooltip: "MPG (PC)",
            minWidth: 100,
            cellStyle: { textAlign: "center" },
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            tooltipValueGetter: lastModTooltip,
        },
        { field: 'Diferencia', headerName: 'DIFERENCIA CONSUMIDO VS AGREGADO (GLLS)',headerTooltip: "DIFERENCIA CONSUMIDO VS AGREGADO (GLLS)",
            minWidth: 100,
            cellClass: classes.cellDiferencia,
            cellStyle: { textAlign: "right" },
            valueGetter: (params) => 
            {
                const raw = params.data?.Diferencia;

                if (raw === null || raw === undefined) return null;

                const cleaned = raw
                    .toString()
                    .replace(/,/g, '')
                    .replace('%', '')
                    .trim();

                if (cleaned === '' || cleaned.toUpperCase() === 'NULL') return null;

                const num = Number(cleaned);

                return Number.isFinite(num) ? num : null;
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            cellClassRules: {
                [classes.cellRed]: (params) => parseNumber(params.value) < 0,
                [classes.cellPurple]: (params) => parseNumber(params.value) > 0
            },
            tooltipValueGetter: lastModTooltip,
        },
        { field: 'Tolerancia', headerName: 'TOLERANCIA % (GLLS)',headerTooltip: "TOLERANCIA % (GLLS)",
            minWidth: 100,
            cellStyle: { textAlign: "right" },
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + ' %';;
            },
            valueGetter: (params) => 
            {
                const raw = params.data?.Tolerancia;

                if (raw === null || raw === undefined) return null;

                const cleaned = raw
                    .toString()
                    .replace(/,/g, '')
                    .replace('%', '')
                    .trim();

                if (cleaned === '' || cleaned.toUpperCase() === 'NULL') return null;

                const num = Number(cleaned);

                return Number.isFinite(num) ? num : null;
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },
            cellClassRules: {
                [classes.cellBrightGreen]: (params) => {
                const val = parseNumber(params.value);
                return val !== null && val >= -7 && val <= 7;
                },
                [classes.cellRed]: (params) => {
                const val = parseNumber(params.value);
                return val !== null && (val < -7 || val > 7);
                }
            },
            tooltipValueGetter: lastModTooltip,
        },
        { field: 'DiferenciaOdometro', headerName: 'DIFERENCIA ODÓMETROS (MI)',headerTooltip: "DIFERENCIA ODÓMETROS (MI)",
            minWidth: 100,
            cellStyle: { textAlign: "right" },
            valueGetter: (params) => 
            {
                const raw = params.data?.DiferenciaOdometro;

                if (raw === null || raw === undefined) return null;

                const cleaned = raw
                    .toString()
                    .replace(/,/g, '')
                    .replace('%', '')
                    .trim();

                if (cleaned === '' || cleaned.toUpperCase() === 'NULL') return null;

                const num = Number(cleaned);

                return Number.isFinite(num) ? num : null;
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            tooltipValueGetter: lastModTooltip,
        },
        { field: 'DiferenciaDistancia', headerName: 'DIFERENCIA DISTANCIAS (MI)',headerTooltip: "DIFERENCIA DISTANCIAS (MI)",
            minWidth: 100,
            cellStyle: { textAlign: "right" },
            valueGetter: (params) => 
            {
                const raw = params.data?.DiferenciaDistancia;

                if (raw === null || raw === undefined) return null;

                const cleaned = raw
                    .toString()
                    .replace(/,/g, '')
                    .replace('%', '')
                    .trim();

                if (cleaned === '' || cleaned.toUpperCase() === 'NULL') return null;

                const num = Number(cleaned);

                return Number.isFinite(num) ? num : null;
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            tooltipValueGetter: lastModTooltip,
        },
        { field: 'trailer_engine_hrs', headerName: 'TRAILER ENGINE HOURS',headerTooltip: "TRAILER ENGINE HOURS",
            minWidth: 100,
            cellStyle: { textAlign: "center" },
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
            },
            tooltipValueGetter: lastModTooltip,
        },
        { field: 'asset_type', headerName: 'TIPO DE UNIDAD',headerTooltip: "TIPO DE UNIDAD",
            cellStyle: { textAlign: "center" },
            cellClassRules: {
                [classes.cellDarkRed]: (params) => params.value === 'USA'
            },
            tooltipValueGetter: lastModTooltip,
        },
        { field: 'brand', headerName: 'MARCA',
            cellStyle: { textAlign: "center" },
            tooltipValueGetter: lastModTooltip,
        },
        { field: 'Asset_trsnport_line', headerName: 'LINEA',headerTooltip: "LINEA",
            cellStyle: { textAlign: "center" },
            tooltipValueGetter: lastModTooltip,
        },
        { field: 'driver', headerName: 'CONDUCTOR', headerTooltip: "CONDUCTOR",
            cellStyle: { textAlign: "center" },
            valueGetter: (params) =>
                params.data?.driver?.toUpperCase() || '',
            tooltipValueGetter: lastModTooltip,
        },
        { field: 'location', headerName: 'FUEL LOCATION',headerTooltip: "FUEL LOCATION",
            cellStyle: { textAlign: "center" },
            cellClassRules: {
                [classes.locationLaredo]: (params) => {if (params.data?.DistanciaOdo === 'INICIAL') return false; return params.value === 'LAREDO'},
                [classes.locationColombia]: (params) => { if (params.data?.DistanciaOdo === 'INICIAL') return false; return params.value === 'COLOMBIA'}
            },
            tooltipValueGetter: lastModTooltip,
        },

                
        { field: 'pc_distance', headerName: 'DISTANCIA (PC)',headerTooltip: "DISTANCIA (PC)",
            minWidth: 100,
            cellStyle: { textAlign: "center" },
            valueGetter: (params) => 
            {
                const raw = params.data?.pc_distance;

                if (raw === null || raw === undefined) return null;

                const cleaned = raw
                    .toString()
                    .replace(/,/g, '')
                    .replace('%', '')
                    .trim();

                if (cleaned === '' || cleaned.toUpperCase() === 'NULL') return null;

                const num = Number(cleaned);

                return Number.isFinite(num) ? num : null;
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            tooltipValueGetter: lastModTooltip,

            cellClassRules: {
                [classes.cellLightRed]: (params) => {
                const diff = getDistanceDiff(params);
                return diff !== null && diff > 1;
                },
                [classes.cellGreen]: (params) => {
                const diff = getDistanceDiff(params);
                return diff !== null && diff <= 1;
                }
            }
        },
        { field: 'pc_diesel_consumed', headerName: 'DIESEL CONSUMIDO (PC)',headerTooltip: "DIESEL CONSUMIDO (PC)",
            minWidth: 100,
            cellStyle: { textAlign: "center" },
            valueGetter: (params) => 
            {
                const raw = params.data?.pc_diesel_consumed;

                if (raw === null || raw === undefined) return null;

                const cleaned = raw
                    .toString()
                    .replace(/,/g, '')
                    .replace('%', '')
                    .trim();

                if (cleaned === '' || cleaned.toUpperCase() === 'NULL') return null;

                const num = Number(cleaned);

                return Number.isFinite(num) ? num : null;
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            tooltipValueGetter: lastModTooltip,
        },
        
        
        
        { field: 'OxxoMasColombia', headerName: 'CANTIDAD (RESET + OXXO) GLLS',headerTooltip: "CANTIDAD (RESET + OXXO) GLLS",
            minWidth: 100,
            cellStyle: { textAlign: "right" },
            valueGetter: (params) => 
            {
                const raw = params.data?.OxxoMasColombia;

                if (raw === null || raw === undefined) return null;

                const cleaned = raw
                    .toString()
                    .replace(/,/g, '')
                    .replace('%', '')
                    .trim();

                if (cleaned === '' || cleaned.toUpperCase() === 'NULL') return null;

                const num = Number(cleaned);

                return Number.isFinite(num) ? num : null;
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            tooltipValueGetter: lastModTooltip,
        },
        
        
        { field: 'gallons', headerName: 'CANTIDAD GLLS',headerTooltip: "CANTIDAD GLLS",
            minWidth: 100,
            cellStyle: { textAlign: "right" },
            valueGetter: (params) => 
            {
                const raw = params.data?.gallons;

                if (raw === null || raw === undefined) return null;

                const cleaned = raw
                    .toString()
                    .replace(/,/g, '')
                    .replace('%', '')
                    .trim();

                if (cleaned === '' || cleaned.toUpperCase() === 'NULL') return null;

                const num = Number(cleaned);

                return Number.isFinite(num) ? num : null;
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            tooltipValueGetter: lastModTooltip,
        },
        { field: 'CantidadOxxo', headerName: 'CANTIDAD GLLS (OXXO)',headerTooltip: "CANTIDAD GLLS (OXXO)",
            minWidth: 100,
            cellStyle: { textAlign: "right" },
            valueGetter: (params) => 
            {
                const raw = params.data?.CantidadOxxo;

                if (raw === null || raw === undefined) return null;

                const cleaned = raw
                    .toString()
                    .replace(/,/g, '')
                    .replace('%', '')
                    .trim();

                if (cleaned === '' || cleaned.toUpperCase() === 'NULL') return null;

                const num = Number(cleaned);

                return Number.isFinite(num) ? num : null;
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            tooltipValueGetter: lastModTooltip,
        },
        { field: 'CantidadOxxoLts', headerName: 'CANTIDAD LTS (OXXO)',headerTooltip: "CANTIDAD LTS (OXXO)",
            minWidth: 100,
            cellStyle: { textAlign: "right" },
            valueGetter: (params) => 
            {
                const raw = params.data?.CantidadOxxoLts;

                if (raw === null || raw === undefined) return null;

                const cleaned = raw
                    .toString()
                    .replace(/,/g, '')
                    .replace('%', '')
                    .trim();

                if (cleaned === '' || cleaned.toUpperCase() === 'NULL') return null;

                const num = Number(cleaned);

                return Number.isFinite(num) ? num : null;
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            tooltipValueGetter: lastModTooltip,
        },


        { field: 'pc_idletime', headerName: 'IDLE TIME (PC)',headerTooltip: "IDLE TIME (PC)",
            minWidth: 100,
            cellStyle: { textAlign: "center" },
            valueFormatter: (params) => {
                if (!params.value) return '';

                const pad = (n) => n.toString().padStart(2, '0');

                if (typeof params.value === 'string' && params.value.includes(':')) {
                    const parts = params.value.split(':');
                    let hours = '00', minutes = '00', seconds = '00';

                    if (parts.length === 3) {
                        [hours, minutes, seconds] = parts;
                    } else if (parts.length === 2) {
                        [hours, minutes] = parts;
                    }

                    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
                }

                const totalHours = parseFloat(params.value);
                if (isNaN(totalHours)) return '';

                let hours = Math.floor(totalHours);
                let minutes = Math.floor((totalHours - hours) * 60);
                let seconds = Math.round(((totalHours - hours) * 60 - minutes) * 60);

                if (seconds === 60) {
                    seconds = 0;
                    minutes += 1;
                }
                if (minutes === 60) {
                    minutes = 0;
                    hours += 1;
                }

                return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
            },
            tooltipValueGetter: lastModTooltip,
        },
        { field: 'pc_fuel_consumed_idle', headerName: 'IDLE FUEL CONSUMIDO (PC)',headerTooltip: "IDLE FUEL CONSUMIDO (PC)",
            minWidth: 100,
            cellStyle: { textAlign: "center" },
            valueGetter: (params) => 
            {
                const raw = params.data?.pc_fuel_consumed_idle;

                if (raw === null || raw === undefined) return null;

                const cleaned = raw
                    .toString()
                    .replace(/,/g, '')
                    .replace('%', '')
                    .trim();

                if (cleaned === '' || cleaned.toUpperCase() === 'NULL') return null;

                const num = Number(cleaned);

                return Number.isFinite(num) ? num : null;
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            tooltipValueGetter: lastModTooltip,
        },
        { field: 'pc_total_time_traveled', headerName: 'TIEMPO TOTAL DE VIAJE (PC)',headerTooltip: "TIEMPO TOTAL DE VIAJE (PC)",
            minWidth: 100,
            cellStyle: { textAlign: "center" },
            valueFormatter: (params) => {
                if (!params.value) return '';

                const pad = (n) => n.toString().padStart(2, '0');

                if (typeof params.value === 'string' && params.value.includes(':')) {
                    const parts = params.value.split(':');
                    let hours = '00', minutes = '00', seconds = '00';

                    if (parts.length === 3) {
                        [hours, minutes, seconds] = parts;
                    } else if (parts.length === 2) {
                        [hours, minutes] = parts;
                    }

                    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
                }

                const totalHours = parseFloat(params.value);
                if (isNaN(totalHours)) return '';

                let hours = Math.floor(totalHours);
                let minutes = Math.floor((totalHours - hours) * 60);
                let seconds = Math.round(((totalHours - hours) * 60 - minutes) * 60);

                if (seconds === 60) {
                    seconds = 0;
                    minutes += 1;
                }
                if (minutes === 60) {
                    minutes = 0;
                    hours += 1;
                }

                return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
            },
            tooltipValueGetter: lastModTooltip,
        },*/
/*         checkColumn('DIÉSEL', 'diesel_chk'),
                checkColumn('CONTABILIDAD', 'contabilidad_chk'),
                checkColumn('OPERACIONES', 'operaciones_chk'),
                {
                    headerName: 'PDF',
                    field: 'pdf',
                    cellRenderer: PdfUploadRenderer,
                    minWidth: 100
                },
                checkColumn('LIQUIDACIONES', 'liquidaciones_chk'),
                *//*
 { 
            headerName: 'VALIDACIONES',
            marryChildren: true,
            children: [
                checkColumn('DIÉSEL', 'diesel_chk'),
                checkColumn('CONTABILIDAD', 'contabilidad_chk'),
                checkColumn('OPERACIONES', 'operaciones_chk'),
                {
                    headerName: 'PDF',
                    field: 'pdf',
                    cellRenderer: PdfUploadRenderer,
                    minWidth: 100
                },
                checkColumn('LIQUIDACIONES', 'liquidaciones_chk'),
                ]
        } 
    ];
    */

    const columns = [
/*         {
            field: "copy",
            headerName: "",
            width: 10,
            disableColumnMenu: true,
            disableExport: true,
            sortable: false,
            filterable: false,
            hideable: false,
            renderCell: (params) => {
                const handleCopy = () => {
                    const rowString = getFormattedRowString(params); 
                    navigator.clipboard.writeText(rowString).then(() => {
                    handleOpenSnackbar(); 
                    });
                };

                return (
                    <MuiTooltip title="Copiar renglón">
                        <IconButton onClick={handleCopy} color="primary">
                            <ContentCopyIcon />
                        </IconButton>
                    </MuiTooltip>
                );
            },
        }, */
        {
            headerName: "",
            field: "copy",
            pinned: true,
            sortable: false,
            filter: false,
            suppressMenu: true,
            suppressColumnsToolPanel: true,
            cellRenderer: (params) => {
                const handleCopy = (e) => {
                const rowString = getFormattedRowString(params.data, columns);
                navigator.clipboard.writeText(rowString).then(() => {
                    handleOpenSnackbar();
                });
                };

                return (
                <MuiTooltip title="Copiar renglón">
                    <IconButton onClick={handleCopy} color="primary" size="small">
                    <ContentCopyIcon fontSize="small" />
                    </IconButton>
                </MuiTooltip>
                );
            },
        },
        {
            field: "fotos",
            headerName: "IMÁGENES",
            headerTooltip: "IMÁGENES",
            suppressCsvExport: true,
            //sortable: false,
            filter: false,
            tooltipValueGetter: lastModTooltip,
            tooltipComponentParams: { className: 'custom-tooltip' },
            cellRenderer: (params) => {
                const fotosValidas = normalizarFotosGrid(params.data?.fotos);

                if (fotosValidas.length === 0) return null;

                return (
                    <BtnAcciones
                        icon={<CollectionsIcon />}
                        label={`Ver (${fotosValidas.length})`}
                        onClick={() =>
                            renderizarDialogGaleria({
                                ...params.data,
                                fotos: fotosValidas
                            })
                        }
                    />
                );
            }
        },
        { field: 'date', headerName: 'FECHA', headerTooltip: "FECHA",
            cellStyle: { textAlign: "center" },
            valueFormatter: (params) => formatDate(params.value),
            pinned: true,
            tooltipValueGetter: lastModTooltip,
        },
        { field: 'asset', headerName: 'UNIDAD',headerTooltip: "UNIDAD",
            cellStyle: { textAlign: "center" },
            pinned: true,
            cellClassRules: {
                [classes.cellDarkRed]: (params) => params.data?.asset_type === 'USA'
            },
            tooltipValueGetter: lastModTooltip,
        },
/*         {
            headerName: "COMPROBANTE",headerTooltip: "COMPROBANTE",
            field: "pc_file",
            //sortable: false,
            filter: false,
            suppressMenu: true,
            suppressColumnsToolPanel: true,
            suppressCsvExport: true,
            cellStyle: { textAlign: "center" },
            tooltipValueGetter: lastModTooltip,
            cellRenderer: (params) => {
                const row = params.data;

                if (row.isTotal) return null;
                if (row.asset_type === 'CAJA') return null;

                const getFileExtension = (filename) => filename?.split('.').pop().toLowerCase();

                const fileName = row.pc_file;

                //const validFileName = /^\d+_\d+\.(pdf|jpg|jpeg|png|webp)$/i.test(fileName);
                const validFileName = /^[a-zA-Z0-9]+_\d+\.(pdf|jpg|jpeg|png|webp)$/i.test(fileName);

                //if (row.pc_file && row.pc_file !== '') 
                if(fileName && validFileName)
                {
                    const ext = getFileExtension(row.pc_file);
                    const isPdf = ext === 'pdf';
                    const isImage = ['jpg', 'jpeg', 'png', 'gif'].includes(ext);

                    return (
                        <Box>
                            <BtnAcciones
                                icon={isPdf ? <PictureAsPdfIcon /> : <ImageIcon />}
                                label={isPdf ? ' Abrir PDF' : ' Abrir imagen'}
                                onClick={() => handleOpenDialog(row, 1, null, isPdf ? 'PDF SUBIDO DE PC' : 'IMAGEN SUBIDA')}
                            />
                        </Box>
                    );
                } 
            }
        }, */
       /*  {
            headerName: "COMPROBANTE",headerTooltip: "COMPROBANTE",
            field: "pc_file",
            //sortable: false,
            filter: false,
            suppressMenu: true,
            suppressColumnsToolPanel: true,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                const row = params.data;

                if (row.isTotal) return null;
                if (row.asset_type === 'CAJA') return null;

                const getFileExtension = (filename) => filename?.split('.').pop().toLowerCase();

                const fileName = row.pc_file;

                //const validFileName = /^\d+_\d+\.(pdf|jpg|jpeg|png|webp)$/i.test(fileName);
                const validFileName = /^[a-zA-Z0-9]+_\d+\.(pdf|jpg|jpeg|png|webp)$/i.test(fileName);

                //if (row.pc_file && row.pc_file !== '') 
                if(fileName && validFileName)
                {
                    const ext = getFileExtension(row.pc_file);
                    const isPdf = ext === 'pdf';
                    const isImage = ['jpg', 'jpeg', 'png', 'gif'].includes(ext);

                    return (
                        <Box>
                            <BtnAcciones
                                icon={isPdf ? <PictureAsPdfIcon /> : <ImageIcon />}
                                label={isPdf ? ' Abrir PDF' : ' Abrir imagen'}
                                onClick={() => handleOpenDialog(row, 1, null, isPdf ? 'PDF SUBIDO DE PC' : 'IMAGEN SUBIDA')}
                            />
                            <BtnAcciones
                                icon={<DeleteIcon />}
                                label={`Eliminar ${isPdf ? 'PDF' : 'imagen'}`}
                                onClick={() => handleDeleteFile(row, isPdf ? 1 : 2)}
                            />
                        </Box>
                    );
                } 
                else 
                {
                    return (
                        <Box>
                            <BtnAcciones
                                icon={<UploadFileIcon />}
                                label="Subir INFO"
                                onClick={() => handleOpenModalFile('PDF', row)}
                            />
                        </Box>
                    );
                }
            }
        }, */
       /*  { 
            field: 'truck_odometer', headerName: 'TRUCK ODÓMETRO',headerTooltip: "TRUCK ODÓMETRO",
            minWidth: 120,
            cellStyle: { textAlign: "center" },
            valueGetter: (params) => {
                if (!params.data?.truck_odometer) return null;
                return Number(params.data.truck_odometer.toString().replace(/,/g, ''));
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            tooltipValueGetter: lastModTooltip,

            cellClassRules: {
                [classes.cellLightRed]: (params) => {
                if (params.data?.DistanciaOdo === 'INICIAL') return false;
                const diff = getOdometerDiff(params);
                return diff !== null && diff > 100;
                },
                [classes.cellGreen]: (params) => {
                if (params.data?.DistanciaOdo === 'INICIAL') return false;
                const diff = getOdometerDiff(params);
                return diff !== null && diff <= 100;
                },
                [classes.cellDarkRed]: (params) => {
                if (params.data?.DistanciaOdo === 'INICIAL') return false;
                return params.data?.asset_type === 'USA'
                }
            }
        }, */
        
       /*  { field: 'pc_truck_odometer', headerName: 'TRUCK ODOMETRO (PC)',headerTooltip: "TRUCK ODOMETRO (PC)",
            minWidth: 120,
            cellStyle: { textAlign: "center" },
            tooltipValueGetter: lastModTooltip,
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            valueGetter: (params) => {
                if (!params.data?.pc_truck_odometer) return null;
                return Number(params.data.pc_truck_odometer.toString().replace(/,/g, ''));
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },

            cellClassRules: {
                [classes.cellLightRed]: (params) => {
                if (params.data?.DistanciaOdo === 'INICIAL') return false;
                const diff = getOdometerDiff(params);
                return diff !== null && diff > 100;
                },
                [classes.cellGreen]: (params) => {
                if (params.data?.DistanciaOdo === 'INICIAL') return false;
                const diff = getOdometerDiff(params);
                return diff !== null && diff <= 100;
                }
            }
        }, */
        
       /*  { field: 'MpgReal', headerName: 'MPG REAL',headerTooltip: "MPG REAL",
            minWidth: 100,
            cellStyle: { textAlign: "center" },
            valueGetter: (params) => {
                const value = params.data.MpgReal;
                if (value === null || value === undefined || value === '' || value === '-') return null;
                const numericValue = Number(value.toString().replace(/,/g, ''));
                return isNaN(numericValue) ? null : numericValue;
            },
            valueFormatter: (params) => {
                const value = params.value;
                const row = params.data;
                if (value === null || value === undefined || value === '') 
                    return ''; 
                if (value === '-') 
                    return value; 
                const numericValue = Number(value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return value; 

                let formatted = numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

                const file = row.pc_file;
                const getFileExtension = (filename) => filename?.split('.').pop().toLowerCase();
                const ext = getFileExtension(file);
                const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext);

                if (!file || isImage) {
                    formatted += ' *';
                }

                return formatted;
            },
            cellClassRules: 
            {
                [classes.cellBlack]: (params) => parseNumber(params.value) === 0,
                [classes.cellBrightGreen]: (params) => parseNumber(params.value) >= 7,
                [classes.cellGreenMedium]: (params) => parseNumber(params.value) >= 6 && parseNumber(params.value) < 7,
                [classes.cellYellow]: (params) => parseNumber(params.value) >= 4 && parseNumber(params.value) < 6,
                [classes.cellRed]: (params) => {
                    const val = parseNumber(params.value);
                    return val !== null && val > 0 && val < 4;
                }
            },
            tooltipValueGetter: lastModTooltip,
        }, */
       /*  { field: 'pc_mpg', headerName: 'MPG (PC)',headerTooltip: "MPG (PC)",
            minWidth: 100,
            cellStyle: { textAlign: "center" },
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            tooltipValueGetter: lastModTooltip,
        }, */
       /*  { field: 'Diferencia', headerName: 'DIFERENCIA CONSUMIDO VS AGREGADO (GLLS)',headerTooltip: "DIFERENCIA CONSUMIDO VS AGREGADO (GLLS)",
            minWidth: 100,
            cellClass: classes.cellDiferencia,
            cellStyle: { textAlign: "right" },
            valueGetter: (params) => 
            {
                const raw = params.data?.Diferencia;

                if (raw === null || raw === undefined) return null;

                const cleaned = raw
                    .toString()
                    .replace(/,/g, '')
                    .replace('%', '')
                    .trim();

                if (cleaned === '' || cleaned.toUpperCase() === 'NULL') return null;

                const num = Number(cleaned);

                return Number.isFinite(num) ? num : null;
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },
            valueFormatter: (params) => 
            {
                if (params.value === null || params.value === undefined)
                    return '';
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            cellClassRules: {
                [classes.cellRed]: (params) => parseNumber(params.value) < 0,
                [classes.cellPurple]: (params) => parseNumber(params.value) > 0
            },
            tooltipValueGetter: lastModTooltip,
        }, */
        /* { field: 'Tolerancia', headerName: 'TOLERANCIA % (GLLS)',headerTooltip: "TOLERANCIA % (GLLS)",
            minWidth: 100,
            cellStyle: { textAlign: "right" },
            valueFormatter: (params) => 
            {
                if (params.value === null || params.value === undefined)
                    return '';
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + ' %';;
            },
            valueGetter: (params) => 
            {
                const raw = params.data?.Tolerancia;

                if (raw === null || raw === undefined) return null;

                const cleaned = raw
                    .toString()
                    .replace(/,/g, '')
                    .replace('%', '')
                    .trim();

                if (cleaned === '' || cleaned.toUpperCase() === 'NULL') return null;

                const num = Number(cleaned);

                return Number.isFinite(num) ? num : null;
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },
            cellClassRules: {
                [classes.cellBrightGreen]: (params) => {
                const val = parseNumber(params.value);
                return val !== null && val >= -7 && val <= 7;
                },
                [classes.cellRed]: (params) => {
                const val = parseNumber(params.value);
                return val !== null && (val < -7 || val > 7);
                }
            },
            tooltipValueGetter: lastModTooltip,
        }, */
        /* { field: 'DiferenciaOdometro', headerName: 'DIFERENCIA ODÓMETROS (MI)',headerTooltip: "DIFERENCIA ODÓMETROS (MI)",
            minWidth: 100,
            cellStyle: { textAlign: "right" },
            valueGetter: (params) => 
            {
                const raw = params.data?.DiferenciaOdometro;

                if (raw === null || raw === undefined) return null;

                const cleaned = raw
                    .toString()
                    .replace(/,/g, '')
                    .replace('%', '')
                    .trim();

                if (cleaned === '' || cleaned.toUpperCase() === 'NULL') return null;

                const num = Number(cleaned);

                return Number.isFinite(num) ? num : null;
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },
            valueFormatter: (params) => 
            {
                if (params.value === null || params.value === undefined)
                    return '';
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            tooltipValueGetter: lastModTooltip,
        }, */
        /* { field: 'DiferenciaDistancia', headerName: 'DIFERENCIA DISTANCIAS (MI)',headerTooltip: "DIFERENCIA DISTANCIAS (MI)",
            minWidth: 100,
            cellStyle: { textAlign: "right" },
            valueGetter: (params) => 
            {
                const raw = params.data?.DiferenciaDistancia;

                if (raw === null || raw === undefined) return null;

                const cleaned = raw
                    .toString()
                    .replace(/,/g, '')
                    .replace('%', '')
                    .trim();

                if (cleaned === '' || cleaned.toUpperCase() === 'NULL') return null;

                const num = Number(cleaned);

                return Number.isFinite(num) ? num : null;
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },
            valueFormatter: (params) => 
            {
                if (params.value === null || params.value === undefined)
                    return '';
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            tooltipValueGetter: lastModTooltip,
        }, */
        { field: 'trailer_engine_hrs', headerName: 'TRAILER ENGINE HOURS',headerTooltip: "TRAILER ENGINE HOURS",
            minWidth: 100,
            cellStyle: { textAlign: "center" },
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
            },
            tooltipValueGetter: lastModTooltip,
        }, 
        { field: 'asset_type', headerName: 'TIPO DE UNIDAD',headerTooltip: "TIPO DE UNIDAD",
            cellStyle: { textAlign: "center" },
            cellClassRules: {
                [classes.cellDarkRed]: (params) => params.value === 'USA'
            },
            tooltipValueGetter: lastModTooltip,
        },
/*         { field: 'brand', headerName: 'MARCA',
            cellStyle: { textAlign: "center" },
            tooltipValueGetter: lastModTooltip,
        },
        { field: 'Asset_trsnport_line', headerName: 'LINEA',headerTooltip: "LINEA",
            cellStyle: { textAlign: "center" },
            tooltipValueGetter: lastModTooltip,
        }, */
        { field: 'driver', headerName: 'CONDUCTOR', headerTooltip: "CONDUCTOR",
            cellStyle: { textAlign: "center" },
            valueGetter: (params) =>
                params.data?.driver?.toUpperCase() || '',
            tooltipValueGetter: lastModTooltip,
        },
        { field: 'HorasLast', headerName: 'HORAS (BASED ON LAST)',headerTooltip: "HORAS (BASED ON LAST)",
            minWidth: 100,
            cellStyle: { textAlign: "center" },
            comparator: (a, b) => 
            {
                const esInicial = (v) => v === 'INICIAL';
                const esNull = (v) => v == null;

                if (esInicial(a) && esInicial(b)) return 0;
                if (esInicial(a)) return -1;
                if (esInicial(b)) return 1;

                if (esNull(a) && esNull(b)) return 0;
                if (esNull(a)) return 1;
                if (esNull(b)) return -1;

                return Number(a) - Number(b);
            },
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
            },
            tooltipValueGetter: lastModTooltip,

            cellClassRules: 
            {
                [classes.cellLightRed]: (params) => {
                const diff = getDistanceDiff(params);
                return diff !== null && diff > 1;
                },
                [classes.cellGreen]: (params) => {
                const diff = getDistanceDiff(params);
                return diff !== null && diff <= 1;
                }
            }
        },
        { field: 'GPH', headerName: 'GPH (Glls per Hr)',headerTooltip: "GPH (Glls per Hr)",
            minWidth: 100,
            cellStyle: { textAlign: "center" },
            valueGetter: (params) => {
                const value = params.data.GPH;
                if (value === null || value === undefined || value === '' || value === '-') return null;
                const numericValue = Number(value.toString().replace(/,/g, ''));
                return isNaN(numericValue) ? null : numericValue;
            },
            valueFormatter: (params) => {
                const value = params.value;
                const row = params.data;
                if (value === null || value === undefined || value === '') 
                    return ''; 
                if (value === '-') 
                    return value; 
                const numericValue = Number(value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return value; 

                let formatted = numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/*                 const file = row.pc_file;
                const getFileExtension = (filename) => filename?.split('.').pop().toLowerCase();
                const ext = getFileExtension(file);
                const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext);

                if (!file || isImage) {
                    formatted += ' *';
                } */

                return formatted;
            },
            /* cellClassRules: 
            {
                [classes.cellBlack]: (params) => parseNumber(params.value) === 0,
                [classes.cellBrightGreen]: (params) => parseNumber(params.value) >= 7,
                [classes.cellGreenMedium]: (params) => parseNumber(params.value) >= 6 && parseNumber(params.value) < 7,
                [classes.cellYellow]: (params) => parseNumber(params.value) >= 4 && parseNumber(params.value) < 6,
                [classes.cellRed]: (params) => {
                    const val = parseNumber(params.value);
                    return val !== null && val > 0 && val < 4;
                }
            }, */
            cellClassRules: {
                [classes.cellBrightGreen]: (params) => {
                if (params.data.HorasLast === 'INICIAL') return false;
                const val = parseNumber(params.value);
                return val !== null && val >= -0.5 && val <= 0.5;
                },
                [classes.cellRed]: (params) => {
                if (params.data.HorasLast === 'INICIAL') return false;
                const val = parseNumber(params.value);
                return val !== null && (val < -0.5 || val > 0.5);
                }
            },
/*             cellClassRules: {
                [classes.cellGreenMedium]: (params) => {
                    if (params.data.HorasLast === 'INICIAL') return false; // no aplicar clase
                    return parseNumber(params.value) <= 0.05;
                },
                [classes.cellRed]: (params) => {
                    if (params.data.HorasLast === 'INICIAL') return false; // no aplicar clase
                    return parseNumber(params.value) > 0.05;
                },
            }, */
            tooltipValueGetter: lastModTooltip,
        },
/*         { field: 'location', headerName: 'RESET LOCATION',headerTooltip: "RESET LOCATION",
            cellStyle: { textAlign: "center" },
            cellClassRules: {
                [classes.locationLaredo]: (params) => {if (params.data?.DistanciaOdo === 'INICIAL') return false; return params.value === 'LAREDO'},
                [classes.locationColombia]: (params) => { if (params.data?.DistanciaOdo === 'INICIAL') return false; return params.value === 'COLOMBIA'}
            },
            tooltipValueGetter: lastModTooltip,
        }, */

                
        /* { field: 'pc_distance', headerName: 'DISTANCIA (PC)',headerTooltip: "DISTANCIA (PC)",
            minWidth: 100,
            cellStyle: { textAlign: "center" },
            valueGetter: (params) => 
            {
                const raw = params.data?.pc_distance;

                if (raw === null || raw === undefined) return null;

                const cleaned = raw
                    .toString()
                    .replace(/,/g, '')
                    .replace('%', '')
                    .trim();

                if (cleaned === '' || cleaned.toUpperCase() === 'NULL') return null;

                const num = Number(cleaned);

                return Number.isFinite(num) ? num : null;
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            tooltipValueGetter: lastModTooltip,

            cellClassRules: {
                [classes.cellLightRed]: (params) => {
                const diff = getDistanceDiff(params);
                return diff !== null && diff > 1;
                },
                [classes.cellGreen]: (params) => {
                const diff = getDistanceDiff(params);
                return diff !== null && diff <= 1;
                }
            }
        }, */
        /* { field: 'pc_diesel_consumed', headerName: 'DIESEL CONSUMIDO (PC)',headerTooltip: "DIESEL CONSUMIDO (PC)",
            minWidth: 100,
            cellStyle: { textAlign: "center" },
            valueGetter: (params) => 
            {
                const raw = params.data?.pc_diesel_consumed;

                if (raw === null || raw === undefined) return null;

                const cleaned = raw
                    .toString()
                    .replace(/,/g, '')
                    .replace('%', '')
                    .trim();

                if (cleaned === '' || cleaned.toUpperCase() === 'NULL') return null;

                const num = Number(cleaned);

                return Number.isFinite(num) ? num : null;
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            tooltipValueGetter: lastModTooltip,
        }, */
        
        
        
        { 
            field: 'TotalRealConsumido', 
            headerName: 'TOTAL GLLS',
            headerTooltip: "TOTAL GLLS",
            minWidth: 100,
            cellStyle: { textAlign: "right" },
            valueGetter: (params) => 
            {
                const raw = params.data?.TotalRealConsumido;

                if (raw === null || raw === undefined) return null;

                const cleaned = raw
                    .toString()
                    .replace(/,/g, '')
                    .replace('%', '')
                    .trim();

                if (cleaned === '' || cleaned.toUpperCase() === 'NULL') return null;

                const num = Number(cleaned);

                return Number.isFinite(num) ? num : null;
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            tooltipValueGetter: lastModTooltip,
        },
        
        
        { field: 'galones_colombia', headerName: 'COLOMBIA GLLS',headerTooltip: "COLOMBIA GLLS",
            minWidth: 100,
            cellStyle: { textAlign: "right" },
            valueGetter: (params) => 
            {
                const raw = params.data?.galones_colombia;

                if (raw === null || raw === undefined) return null;

                const cleaned = raw
                    .toString()
                    .replace(/,/g, '')
                    .replace('%', '')
                    .trim();

                if (cleaned === '' || cleaned.toUpperCase() === 'NULL') return null;

                const num = Number(cleaned);

                return Number.isFinite(num) ? num : null;
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            tooltipValueGetter: lastModTooltip,
        },
        { field: 'CantidadOxxo', headerName: 'OXXO GLLS',headerTooltip: "OXXO GLLS",
            minWidth: 100,
            cellStyle: { textAlign: "right" },
            valueGetter: (params) => 
            {
                const raw = params.data?.CantidadOxxo;

                if (raw === null || raw === undefined) return null;

                const cleaned = raw
                    .toString()
                    .replace(/,/g, '')
                    .replace('%', '')
                    .trim();

                if (cleaned === '' || cleaned.toUpperCase() === 'NULL') return null;

                const num = Number(cleaned);

                return Number.isFinite(num) ? num : null;
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            tooltipValueGetter: lastModTooltip,
        },
        /* { field: 'CantidadOxxoLts', headerName: 'OXXO CANTIDAD LTS',headerTooltip: "OXXO CANTIDAD LTS",
            minWidth: 100,
            cellStyle: { textAlign: "right" },
            valueGetter: (params) => 
            {
                const raw = params.data?.CantidadOxxoLts;

                if (raw === null || raw === undefined) return null;

                const cleaned = raw
                    .toString()
                    .replace(/,/g, '')
                    .replace('%', '')
                    .trim();

                if (cleaned === '' || cleaned.toUpperCase() === 'NULL') return null;

                const num = Number(cleaned);

                return Number.isFinite(num) ? num : null;
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            tooltipValueGetter: lastModTooltip,
        }, */

        { field: 'CantidadLoves', headerName: 'LOVES GLLS',headerTooltip: "LOVES GLLS",
            minWidth: 100,
            cellStyle: { textAlign: "right" },
            valueGetter: (params) => 
            {
                const raw = params.data?.CantidadLoves;

                if (raw === null || raw === undefined) return null;

                const cleaned = raw
                    .toString()
                    .replace(/,/g, '')
                    .replace('%', '')
                    .trim();

                if (cleaned === '' || cleaned.toUpperCase() === 'NULL') return null;

                const num = Number(cleaned);

                return Number.isFinite(num) ? num : null;
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            tooltipValueGetter: lastModTooltip,
        },

        { field: 'CantidadTorre', headerName: 'ARGUIDENGUI GLLS',headerTooltip: "ARGUIDENGUI GLLS",
            minWidth: 100,
            cellStyle: { textAlign: "right" },
            valueGetter: (params) => 
            {
                const raw = params.data?.CantidadTorre;

                if (raw === null || raw === undefined) return null;

                const cleaned = raw
                    .toString()
                    .replace(/,/g, '')
                    .replace('%', '')
                    .trim();

                if (cleaned === '' || cleaned.toUpperCase() === 'NULL') return null;

                const num = Number(cleaned);

                return Number.isFinite(num) ? num : null;
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            tooltipValueGetter: lastModTooltip,
        },


        /* { field: 'pc_idletime', headerName: 'IDLE TIME (PC)',headerTooltip: "IDLE TIME (PC)",
            minWidth: 100,
            cellStyle: { textAlign: "center" },
            valueFormatter: (params) => formatTime(params.value),
            /* valueFormatter: (params) => {
                if (!params.value) return '';

                const pad = (n) => n.toString().padStart(2, '0');

                if (typeof params.value === 'string' && params.value.includes(':')) {
                    const parts = params.value.split(':');
                    let hours = '00', minutes = '00', seconds = '00';

                    if (parts.length === 3) {
                        [hours, minutes, seconds] = parts;
                    } else if (parts.length === 2) {
                        [hours, minutes] = parts;
                    }

                    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
                }

                const totalHours = parseFloat(params.value);
                if (isNaN(totalHours)) return '';

                let hours = Math.floor(totalHours);
                let minutes = Math.floor((totalHours - hours) * 60);
                let seconds = Math.round(((totalHours - hours) * 60 - minutes) * 60);

                if (seconds === 60) {
                    seconds = 0;
                    minutes += 1;
                }
                if (minutes === 60) {
                    minutes = 0;
                    hours += 1;
                }

                return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
            }, 
            tooltipValueGetter: lastModTooltip,
        }, */
        /* { field: 'pc_fuel_consumed_idle', headerName: 'IDLE FUEL CONSUMIDO (PC)',headerTooltip: "IDLE FUEL CONSUMIDO (PC)",
            minWidth: 100,
            cellStyle: { textAlign: "center" },
            valueGetter: (params) => 
            {
                const raw = params.data?.pc_fuel_consumed_idle;

                if (raw === null || raw === undefined) return null;

                const cleaned = raw
                    .toString()
                    .replace(/,/g, '')
                    .replace('%', '')
                    .trim();

                if (cleaned === '' || cleaned.toUpperCase() === 'NULL') return null;

                const num = Number(cleaned);

                return Number.isFinite(num) ? num : null;
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            tooltipValueGetter: lastModTooltip,
        }, */
       /*  { field: 'pc_total_time_traveled', headerName: 'TIEMPO TOTAL DE VIAJE (PC)',headerTooltip: "TIEMPO TOTAL DE VIAJE (PC)",
            minWidth: 100,
            cellStyle: { textAlign: "center" },
            valueFormatter: (params) => formatTime(params.value),
           /*  valueFormatter: (params) => {
                if (!params.value) return '';

                const pad = (n) => n.toString().padStart(2, '0');

                if (typeof params.value === 'string' && params.value.includes(':')) {
                    const parts = params.value.split(':');
                    let hours = '00', minutes = '00', seconds = '00';

                    if (parts.length === 3) {
                        [hours, minutes, seconds] = parts;
                    } else if (parts.length === 2) {
                        [hours, minutes] = parts;
                    }

                    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
                }

                const totalHours = parseFloat(params.value);
                if (isNaN(totalHours)) return '';

                let hours = Math.floor(totalHours);
                let minutes = Math.floor((totalHours - hours) * 60);
                let seconds = Math.round(((totalHours - hours) * 60 - minutes) * 60);

                if (seconds === 60) {
                    seconds = 0;
                    minutes += 1;
                }
                if (minutes === 60) {
                    minutes = 0;
                    hours += 1;
                }

                return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
            }, 
            tooltipValueGetter: lastModTooltip,
        }, */
/*         checkColumn('DIÉSEL', 'diesel_chk'),
        checkColumn('CONTABILIDAD', 'contabilidad_chk'),
        checkColumn('OPERACIONES', 'operaciones_chk'),
        {
            headerName: 'PDF',
            field: 'pdf',
            cellRenderer: PdfUploadRenderer,
            minWidth: 100
        },
        checkColumn('LIQUIDACIONES', 'liquidaciones_chk'), */
/*         checkColumn('DIÉSEL', 'diesel_chk'),
                checkColumn('CONTABILIDAD', 'contabilidad_chk'),
                checkColumn('OPERACIONES', 'operaciones_chk'),
                {
                    headerName: 'PDF',
                    field: 'pdf',
                    cellRenderer: PdfUploadRenderer,
                    minWidth: 100
                },
                checkColumn('LIQUIDACIONES', 'liquidaciones_chk'),
                */
/*  { 
            headerName: 'VALIDACIONES',
            marryChildren: true,
            children: [
                checkColumn('DIÉSEL', 'diesel_chk'),
                checkColumn('CONTABILIDAD', 'contabilidad_chk'),
                checkColumn('OPERACIONES', 'operaciones_chk'),
                {
                    headerName: 'PDF',
                    field: 'pdf',
                    cellRenderer: PdfUploadRenderer,
                    minWidth: 100
                },
                checkColumn('LIQUIDACIONES', 'liquidaciones_chk'),
                ]
        }  */
       {
                   headerName: "ACCIONES",headerTooltip: "ACCIONES",
                   field: "actions",
                   minWidth: 150,
                   sortable: false,
                   filter: false,
                   suppressMenu: true,
                   suppressColumnsToolPanel: true,
                   cellRenderer: (params) => {
                       const row = params.data;
                       if (row.isTotal) return null;
                       return (
                       <div style={{ display: "flex", gap: 8 }}>
                           <BtnAcciones
                           icon={<BorderColorIcon />}
                           label="Editar"
                           onClick={() => handleEdit(params.data)}   // fila completa
                           />
                           <BtnAcciones
                           icon={<DeleteIcon />}
                           label="Eliminar"
                           onClick={() => handleDelete(params.data.id)}
                           />
                       </div>
                       );
                   },
               }
    ];

    const handleEdit = useCallback(async (fuelRow) => {
            handleOpenModal(data.find(carga => carga.id === fuelRow.id));
            setIsEditing(true);
            setSelected(fuelRow);
            
        }, []);

         const handleDelete = useCallback(async (id) => {
                try {
                    Swal.fire({
                        title: '¿Estás seguro de eliminar este reset?',
                        icon: 'question',
                        showCancelButton: true,
                        confirmButtonText: 'Sí, eliminar',
                        cancelButtonText: 'Cancelar',
                        confirmButtonColor: 'green',
                        cancelButtonColor: 'red',
                    }).then(async (result) => {
                        if (result.isConfirmed) {
                            let { data } = await myApi.delete(`/cargasFuel/deleteReset/${id}`);
        
                            if (data.success) {
                                Swal.fire({
                                    icon: 'success',
                                    title: 'Reset eliminado',
                                });
        
                                setData(prevData => prevData.filter(carga => carga.id !== id));
                            } else {
                                Swal.fire({
                                    icon: 'error',
                                    title: 'Error al eliminar el reset',
                                });
                            }
                        }
                    });
                    
                } catch (error) {
                    console.error('Error deleting reset:', error);
                }
            }, []);

    const columnsRA = 
    [
        {
            headerName: "",
            field: "copy",
            pinned: true,
            sortable: false,
            filter: false,
            suppressMenu: true,
            suppressColumnsToolPanel: true,
            cellRenderer: (params) => {
                const handleCopy = (e) => {
                const rowString = getFormattedRowString(params.data, columnsRA);
                navigator.clipboard.writeText(rowString).then(() => {
                    handleOpenSnackbar();
                });
                };

                return (
                <MuiTooltip title="Copiar renglón">
                    <IconButton onClick={handleCopy} color="primary" size="small">
                    <ContentCopyIcon fontSize="small" />
                    </IconButton>
                </MuiTooltip>
                );
            },
        },
        { 
            field: 'ranking', 
            headerName: 'RANKING', 
            headerTooltip: "RANKING",
            cellStyle: { textAlign: "center" }
        },
        { 
            field: 'asset', 
            headerName: 'UNIDAD',
            headerTooltip: "UNIDAD",
            cellStyle: { textAlign: "center" }
        },
        { 
            field: 'diferencia_total_galones', 
            headerName: 'DIFERENCIA CONSUMIDO VS AGREGADO (GLLS)',headerTooltip: "DIFERENCIA CONSUMIDO VS AGREGADO (GLLS)",
            minWidth: 100,
            cellClass: classes.cellDiferencia,
            cellStyle: { textAlign: "right" },
            valueGetter: (params) => 
            {
                const raw = params.data?.diferencia_total_galones;

                if (raw === null || raw === undefined) return null;

                const cleaned = raw
                    .toString()
                    .replace(/,/g, '')
                    .replace('%', '')
                    .trim();

                if (cleaned === '' || cleaned.toUpperCase() === 'NULL') return null;

                const num = Number(cleaned);

                return Number.isFinite(num) ? num : null;
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            cellClassRules: {
                [classes.cellRed]: (params) => parseNumber(params.value) < 0,
                [classes.cellPurple]: (params) => parseNumber(params.value) > 0
            }
        }
    ];

    const columnsRD = 
    [
        {
            headerName: "",
            field: "copy",
            pinned: true,
            sortable: false,
            filter: false,
            suppressMenu: true,
            suppressColumnsToolPanel: true,
            cellRenderer: (params) => {
                const handleCopy = (e) => {
                const rowString = getFormattedRowString(params.data, columnsRD);
                navigator.clipboard.writeText(rowString).then(() => {
                    handleOpenSnackbar();
                });
                };

                return (
                <MuiTooltip title="Copiar renglón">
                    <IconButton onClick={handleCopy} color="primary" size="small">
                    <ContentCopyIcon fontSize="small" />
                    </IconButton>
                </MuiTooltip>
                );
            },
        },
        { 
            field: 'ranking', 
            headerName: 'RANKING', 
            headerTooltip: "RANKING",
            cellStyle: { textAlign: "center" }
        },
        { 
            field: 'driver', 
            headerName: 'CONDUCTOR',
            headerTooltip: "CONDUCTOR",
            cellStyle: { textAlign: "center" },
            valueGetter: (params) =>
                params.data?.driver?.toUpperCase() || ''
        },
        { 
            field: 'diferencia_total_galones', 
            headerName: 'DIFERENCIA CONSUMIDO VS AGREGADO (GLLS)',headerTooltip: "DIFERENCIA CONSUMIDO VS AGREGADO (GLLS)",
            minWidth: 100,
            cellClass: classes.cellDiferencia,
            cellStyle: { textAlign: "right" },
            valueGetter: (params) => 
            {
                const raw = params.data?.diferencia_total_galones;

                if (raw === null || raw === undefined) return null;

                const cleaned = raw
                    .toString()
                    .replace(/,/g, '')
                    .replace('%', '')
                    .trim();

                if (cleaned === '' || cleaned.toUpperCase() === 'NULL') return null;

                const num = Number(cleaned);

                return Number.isFinite(num) ? num : null;
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            cellClassRules: {
                [classes.cellRed]: (params) => parseNumber(params.value) < 0,
                [classes.cellPurple]: (params) => parseNumber(params.value) > 0
            }
        }
    ];

    const fetch = async (unidad = null, fi = null, ff = null, tipo = null, rankingAssetsParam = rankingAssets, rankingDriversParam = rankingDrivers) => 
    {
        setLoading(true);
        try 
        {
            const datosEnviados = { unidad, fi, ff, tipo, colorGPH, sorted, typeOf, company, rankingAssets: rankingAssetsParam, rankingDrivers: rankingDriversParam };
            const response = await myApi.post('/cargasFuel/getDashMPGCajas', datosEnviados);
            console.log(response)
            if(response.data.success)
                setData(response.data.data);
            else
                setData([]);
        } 
        catch(error) 
        {
            console.error('Error fetching fuel loads:', error);
        }
        finally 
        {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetch();
    }, []);

    const handleSubmit = async (e) => 
    {
        const newRankingAssets = false;
        setRankingAssets(newRankingAssets);

        const newRankingDrivers = false;
        setRankingDrivers(newRankingDrivers);

        let fechainicial = null, fechafinal = null, unidad = null, tipo = null;
        if (startDate && startDate.$d!='Invalid Date')
            fechainicial = startDate.$d.toJSON().substring(0, 10);
        if (endDate && endDate.$d!='Invalid Date')
            fechafinal = endDate.$d.toJSON().substring(0, 10);
        if (unit && unit != 'undefined' && unit != '')
            unidad = unit;
        if (type && type != 'undefined' && type != '')
            tipo = type;

        await fetch(unidad, fechainicial, fechafinal, tipo, newRankingAssets, newRankingDrivers);
    };

    const totalsRow = React.useMemo(() => {
        const sum = (field) =>
            data.reduce((acc, row) => acc + (Number(row[field]) || 0), 0);

        const avg = (field) => {
            const valid = data.filter(r => Number(r[field]));
            if (!valid.length) return 0;
            return sum(field) / valid.length;
        };

        return {
            id: 'totals',
            asset: 'TOTAL',
            isTotal: true, 
            gallons: sum('gallons'),
            liters: sum('liters'),
            price: avg('price'),   
            total: sum('total'),
        };
    }, [data]);

    useEffect(() => {
        if (gridRef.current?.api) 
        {
            if (!data || data.length === 0) 
            {
                gridRef.current.api.showLoadingOverlay();
            } 
            else 
            {
                gridRef.current.api.hideOverlay();
            }
        }
    }, [data]);

    const onGridReady = (params) => 
    {
        params.api.sizeColumnsToFit();
    };

    const onFirstDataRendered = (params) => 
    {
        const columns = params.api.getColumns();

        const colsToAutoSize = columns
            .filter(col => {
            const def = col.getColDef();
            return !col.isPinned() && !def.cellRenderer;
            })
            .map(col => col.getColId());
            
        params.api.autoSizeColumns(colsToAutoSize, true);
    };

    const CHECK_COLUMNS = [
  'diesel_chk',
  'contabilidad_chk',
  'operaciones_chk',
  'liquidaciones_chk'
];


/*  const handleExport = () => 
    {
        const columnDefs = gridRef.current.api.getColumnDefs();

        const columnasAExportar = columnDefs
            .filter(col =>
            col.field &&
            !['fotos', 'pc_file', 'copy', 'pdf'].includes(col.field)
            )
            .map(col => col.field);

        gridRef.current.api.exportDataAsCsv({
            columnKeys: columnasAExportar,
            processCellCallback: (params) => {
                const field = params.column.getColId();

                if (field.endsWith('_chk')) {
                    return params.value === '1'
                    ? 'VALIDADO'
                    : 'NO VALIDADO';
                }

                return params.value;
            }
        });
    };   */  

    const handleExport = () => 
    {
        const api = gridRef.current?.api;
        const columnDefs = gridRef.current.api.getColumnDefs();
        if (!api || !columnDefs) return;

        // columnas reales visibles (sin grupos)
        const columnasBase = columnDefs
            .filter(col =>
            col.field &&
            !['fotos', 'pc_file', 'copy', 'pdf', 'diesel_chk', 'contabilidad_chk', 'operaciones_chk', 'liquidaciones_chk', 'actions'].includes(col.field)
            )
            .map(col => col.field);

        // combinar + quitar duplicados
        const columnasAExportar = Array.from(
            new Set([...columnasBase, ...CHECK_COLUMNS])
        );

        api.exportDataAsCsv({
            columnKeys: columnasAExportar,

            processHeaderCallback: (params) => {
            const map = {
                diesel_chk: 'DIÉSEL',
                contabilidad_chk: 'CONTABILIDAD',
                operaciones_chk: 'OPERACIONES',
                liquidaciones_chk: 'LIQUIDACIONES'
            };
            return map[params.column.getColId()] || params.column.getColDef().headerName;
            },

            processCellCallback: (params) => {
            const field = params.column.getColId();

/*             if (field === 'date') 
            {
                return formatDate(params.value);
            } */

            if (field === 'date') {
                return formatDate(params.value) + '\u200B';
            }

            if (field === 'pc_idletime' || field === 'pc_total_time_traveled') {
                const value = formatTime(params.value);
                return value ? `${value}\u00A0` : '';
            }

            if (field.endsWith('_chk')) {
                return params.value === '1'
                ? 'VALIDADO'
                : 'NO VALIDADO';
            }

            return params.value;
            }
        });
    };

    {/* <Button variant="contained" onClick={() => gridRef.current.api.exportDataAsCsv()} sx={{ mb: 1 }}> Exportar a Excel </Button> */}

    const [openLegend, setOpenLegend] = useState(false);

    const handleRankingByUnit = async () => 
    {
        const newRankingAssets = true;
        setRankingAssets(newRankingAssets);

        const newRankingDrivers = false;
        setRankingDrivers(newRankingDrivers);

        let fechainicial = null, fechafinal = null, unidad = null, tipo = null;
        if (startDate && startDate.$d!='Invalid Date')
            fechainicial = startDate.$d.toJSON().substring(0, 10);
        if (endDate && endDate.$d!='Invalid Date')
            fechafinal = endDate.$d.toJSON().substring(0, 10);
        if (unit && unit != 'undefined' && unit != '')
            unidad = unit;
        if (type && type != 'undefined' && type != '')
            tipo = type;
        await fetch(unidad, fechainicial, fechafinal, tipo, newRankingAssets, newRankingDrivers);
    };

    const handleRankingByDriver = async () => 
    {
        const newRankingDrivers = true;
        setRankingDrivers(newRankingDrivers);

        const newRankingAssets = false;
        setRankingAssets(newRankingAssets);

        let fechainicial = null, fechafinal = null, unidad = null, tipo = null;
        if (startDate && startDate.$d!='Invalid Date')
            fechainicial = startDate.$d.toJSON().substring(0, 10);
        if (endDate && endDate.$d!='Invalid Date')
            fechafinal = endDate.$d.toJSON().substring(0, 10);
        if (unit && unit != 'undefined' && unit != '')
            unidad = unit;
        if (type && type != 'undefined' && type != '')
            tipo = type;
        await fetch(unidad, fechainicial, fechafinal, tipo, newRankingAssets, newRankingDrivers);
    };

    const [openFilters, setOpenFilters] = useState(false);

    const handleClearAll = () => 
    {
        setUnit('');
        setStartDate(null);
        setEndDate(null);
        setType('TODO');
        setSorted('FECHA');
        setColorGPH('TODO');
        setTypeOf('TODO');
        setCompany('TODAS');
    };

    const clearFilter = (filter) => 
    {
        switch (filter) 
        {
            case 'unit':
            setUnit('');
            break;
            case 'startDate':
            setStartDate(null);
            break;
            case 'endDate':
            setEndDate(null);
            break;
            case 'type':
            setType('TODO');
            break;
            case 'sorted':
            setSorted('FECHA');
            break;
            case 'colorGPH':
            setColorGPH('TODO');
            break;
            case 'typeOf':
            setTypeOf('TODO');
            break;
            case 'company':
            setCompany('TODAS');
            break;
            default:
            break;
        }
    };

    const handleOpenModal = (carga = null) => {
        setSelected(carga);
        setIsEditing(!!carga);
        setModalOpen(true);
    };

    const calcularCampos = (row) => 
    {
        const Diferencia =
            row.DistanciaOdo === 'INICIAL'
                ? '-'
                : row.asset_type === 'CAJA'
                    ? null
                    : row.pc_diesel_consumed != null
                        ? Number(
                            (row.pc_diesel_consumed - row.TotalRealConsumido).toFixed(2)
                        )
                        : null;

        const Tolerancia =
            row.DistanciaOdo === 'INICIAL'
                ? '-'
                : row.asset_type === 'CAJA'
                    ? null
                    : row.pc_diesel_consumed != null && row.pc_diesel_consumed !== 0
                        ? Number(
                            (
                                ((row.pc_diesel_consumed - row.TotalRealConsumido) /
                                    row.pc_diesel_consumed) *
                                100
                            ).toFixed(2)
                        )
                        : null;

        const DiferenciaOdometro =
            row.truck_odometer_num == null || row.pc_truck_odometer == null
                ? null
                : Math.abs(row.truck_odometer_num - row.pc_truck_odometer);

        const DiferenciaDistancia =
            row.DistanciaOdo === 'INICIAL' ||
            row.DistanciaOdo == null ||
            row.pc_distance == null
                ? null
                : Math.abs(row.DistanciaOdo - row.pc_distance);

        return {
            Diferencia,
            Tolerancia,
            DiferenciaOdometro,
            DiferenciaDistancia
        };
    };

    const updateRow = (rowActualizada) => {
        setData(prev =>
            prev.map(r => {
                if (r.id !== rowActualizada.id) return r;

                const mergedRow = {
                    ...r,
                    ...rowActualizada,
                };

                const calculados = calcularCampos(mergedRow);

                return {
                    ...mergedRow,
                    ...calculados,
                };
            })
        );
    };


/*     const updateRow = (rowActualizada) => {
        setData(prev =>
            prev.map(r =>
                r.id === rowActualizada.id
                    ? { ...r, ...rowActualizada }
                    : r
            )
        );
    }; */

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const iconoActual =
    tipoActual === 'CAJAS' ? (
    <Inventory2Icon fontSize="small" sx={{ mr: 0.5 }} />
    ) : (
    <LocalShippingIcon fontSize="small" sx={{ mr: 0.5 }} />
    );

        const handleClose = () => {
        setAnchorEl(null);
    };

    const cambiarVista = (ruta) => {
        navigate(ruta);
        handleClose();
    };

    return (
    <>
        <Paper
            sx={{
                p: 2,
                height: "calc(100vh - 125px)",
                width: "100%",
                maxWidth: "100%",
                display: "flex",
                flexDirection: "column",
                boxSizing: "border-box",
            }}
        >
        <Box sx={{ flexShrink: 0 }}>
            <form onSubmit={(e) => e.preventDefault()}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1, width: "100%", minWidth: 0 }}>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 2,
                            width: "100%",
                            minWidth: 0,
                            flexWrap: "nowrap",
                        }}
                    >
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0, overflow: "hidden" }}>
                            <Typography
                                variant="h4"
                                fontWeight={700}
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    minWidth: 0,
                                    whiteSpace: "nowrap",
                                }}
                            >
                                <Box component="span" color="primary.main">
                                    Dashboard
                                </Box>
                                {' '}· MPG ·{' '}
                                <Button
                                    variant="outlined"
                                    endIcon={<ExpandMoreIcon />}
                                    onClick={handleOpen}
                                    startIcon={tipoActual === 'CAJAS' ? <Inventory2Icon /> : <LocalShippingIcon />}
                                >
                                    {tipoActual === 'CAJAS' ? 'Cajas' : 'Tractores'}
                                </Button>
                                <Menu
                                    anchorEl={anchorEl}
                                    open={open2}
                                    onClose={handleClose}
                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                >
                                    <MenuItem onClick={() => cambiarVista('/diesel/fuel_up/v2/master_dashboard/cajas')}>
                                        <Inventory2Icon fontSize="small" sx={{ mr: 1 }} />
                                        Cajas
                                    </MenuItem>
                
                                    <MenuItem onClick={() => cambiarVista('/diesel/fuel_up/v2/master_dashboard/tractores')}>
                                        <LocalShippingIcon fontSize="small" sx={{ mr: 1 }} />
                                        Tractores
                                    </MenuItem>
                                </Menu>
                            </Typography>
                        </Box>
                        <Stack
                            direction="row"
                            spacing={1}
                            sx={{
                            flexShrink: 0,
                            justifyContent: "flex-end",
                            alignItems: "center",
                            whiteSpace: "nowrap",
                            }}
                        >
                            <Button
                                variant="outlined"
                                startIcon={<TuneIcon />}
                                onClick={() => setOpenFilters(true)}
                            >
                                Filtros
                            </Button>

                            <Button
                                variant="outlined"
                                startIcon={<AddIcon />}
                                color="primary"
                                onClick={() => handleOpenModal()}
                            >
                                Agregar
                            </Button>

                            <Button
                                variant="contained"
                                startIcon={<ManageSearchIcon />}
                                onClick={handleSubmit}
                            >
                                Buscar
                            </Button>
                        </Stack>
                    </Box>
                    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ width: "100%" }}>
                        {unit && (
                            <Chip
                            label={`Unidad: ${unit}`}
                            onDelete={() => clearFilter('unit')}
                            />
                        )}

                        {startDate && (
                            <Chip
                            label={`Desde: ${formatDate(startDate).substring(0, 8)}`}
                            onDelete={() => clearFilter('startDate')}
                            />
                        )}

                        {endDate && (
                            <Chip
                            label={`Hasta: ${formatDate(endDate).substring(0, 8)}`}
                            onDelete={() => clearFilter('endDate')}
                            />
                        )}

                        {type !== 'TODO' && (
                            <Chip
                            label={`Filtro: ${type}`}
                            onDelete={() => clearFilter('type')}
                            />
                        )}

                        {sorted !== 'FECHA' && (
                            <Chip
                            label={`Ver por: ${sorted}`}
                            onDelete={() => clearFilter('sorted')}
                            />
                        )}

                        {colorGPH !== 'TODO' && (
                            <Chip
                            label={colorGPH === 'ROJOS' ? 'Solo rojos' : colorGPH}
                            onDelete={() => clearFilter('colorGPH')}
                            sx={{
                                fontWeight: 'bold',
                                color: '#d32f2f',
                                borderColor: '#d32f2f'
                            }}
                            variant="outlined"
                            />
                        )}

                        {typeOf !== 'TODO' && (
                            <Chip
                            label={`Tipo: ${typeOf}`}
                            onDelete={() => clearFilter('typeOf')}
                            />
                        )}

                        {company !== 'TODAS' && (
                            <Chip
                            label={`Compañía: ${company}`}
                            onDelete={() => clearFilter('company')}
                            />
                        )}
                    </Stack>
                    <Drawer
                        anchor="right"
                        open={openFilters}
                        onClose={() => setOpenFilters(false)}
                    >
                        <Box sx={{ width: 360, p: 2 }}>
                            <Typography variant="h6" fontWeight="bold" mb={2}>
                                Filtros
                            </Typography>

                            <Stack spacing={2}>
                                {/* Campo de Unidad */}
                                <TextField
                                    label="Unidad"
                                    variant="outlined"
                                    value={unit}
                                    onChange={handleChangeUnidad}
                                    fullWidth
                                />

                                {/* Campo de Fecha Inicial y Campo de Fecha Final */}
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        value={startDate}
                                        onChange={handleChangeStartDate}
                                        format="MM/DD/YY"
                                        label="Fecha Inicial"
                                        fullWidth
                                    />
                                    <DatePicker
                                        value={endDate}
                                        onChange={handleChangeEndDate}
                                        format="MM/DD/YY"
                                        label="Fecha Final"
                                        fullWidth
                                    />
                                </LocalizationProvider>

                                {/* Filtro GPH COLOR*/}
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel id="filtro-label">GPH</InputLabel>
                                    <Select
                                        labelId="color-label"
                                        value={colorGPH}
                                        onChange={(e) => handleChangeColorGPH(e)}
                                        label="Color GPH"
                                        displayEmpty
                                        renderValue={(selected) => {
                                            if (!selected || selected === 'TODO') return 'TODO';
                                            const colorMap = {
                                            ROJOS: '#ff0000'
                                            };
                                            return (
                                            <span style={{ color: colorMap[selected] || '#000', fontWeight: 'bold' }}>
                                                {selected === 'ROJOS' ? 'SOLO ROJOS' : selected}
                                            </span>
                                            );
                                        }}
                                    >
                                        <MenuItem value="TODO">TODO</MenuItem>
                                        <MenuItem 
                                            value="ROJOS" 
                                            sx={{ color: '#ff0000', fontWeight: 'bold' }} 
                                        >
                                            SOLO ROJOS
                                        </MenuItem>
                                    </Select>
                                </FormControl>

                                <Divider />

                                <Stack direction="row" spacing={1} justifyContent="flex-end">
                                    <Button
                                    variant="text"
                                    onClick={() => {
                                        handleClearAll(); // opcional
                                    }}
                                    >
                                    Limpiar
                                    </Button>

                                    <Button
                                    variant="contained"
                                    onClick={() => {
                                        handleSubmit();
                                        setOpenFilters(false);
                                    }}
                                    >
                                    Aplicar
                                    </Button>
                                </Stack>
                            </Stack>
                        </Box>
                    </Drawer>
                </Box>
            </form>
            </Box>
            {/** {LISTA DE CAJAS} */}
            <Box sx={{ flex: 1, minHeight: 0, mt: 1, display: "flex", flexDirection: "column" }}>
                { loading ? (
                    <Box sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <img
                            alt="Cargando..."
                            width="200px"
                            height="200px"
                            src={img} 
                            style={{ cursor: "pointer", borderRadius: "50%" }}
                        />
                    </Box>
                ) : (
                    <>                 
                    <Box sx={{ flexShrink: 0, mb: 1, display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                        <Button variant="contained" onClick={() => handleExport() } sx={{ mb: 1 }}>
                            Exportar a Excel
                        </Button>
                    </Box>
                    <Box sx={{ width: "100%", flex: 1, minHeight: 0, my: 1, display: "flex", flexDirection: "column" }}>
                    <div 
                        className="ag-theme-quartz" 
                        style={{ 
                            height: "100%", 
                            width: "100%" 
                        }}
                    >
                        {!rankingAssets && !rankingDrivers && (
                            <AgGridReact
                                modules={[AllCommunityModule]}
                                ref={gridRef}
                                rowData={data}
                                columnDefs={columns}
                                pagination={true}
                                getRowId={(params) => params.data.id}
                                getRowClass={(params) => {
                                    if (params.data?.HorasLast === "INICIAL") {
                                        return classes.rowBlue; 
                                    }
                                    return null; 
                                }}
                                autoSizeStrategy={{
                                    type: 'fitCellContents',
                                    skipHeader: true
                                }}
                                onGridReady={onGridReady}
                                onFirstDataRendered={onFirstDataRendered}
                                enableCellTextSelection={true}
                            />
                        )}
                    </div>
                </Box>
                </>
                )
            } 
        </Box>
        </Paper>
        {/* {MODAL EDITAR/CREAR} */}
        <CrearEditarModal
            open={modalOpen}
            onClose={() => setModalOpen(false)}
            refresh={fetch}
            carga={selected}
            isEditing={isEditing}
            onUpdate={updateRow}
            tipo={'CAJA'}
        />
        {/* {MODALES} */}
        <SubirModal
            open={pdfModalOpen}
            onClose={() => setPdfModalOpen(false)} 
            rowData={selectedRow} 
            refresh={fetch}
            onUpdate={updateRow}
        />
        {selectedRow && (
            <GalleryDialog
                open={openGallery}
                onClose={handleCloseGallery}
                fotos={selectedRow?.fotos || []}
            />
        )}
        <ColorLegendDialog
            open={openLegend}
            onClose={() => setOpenLegend(false)}
            classes={classes}
        />
        <Snackbar
            open={snackbarOpen}
            autoHideDuration={2000}
            onClose={handleCloseSnackbar}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
            <Alert onClose={handleCloseSnackbar} severity="success" variant="filled">
                Texto copiado al portapapeles ✅
            </Alert>
        </Snackbar>
    </>
    )

}

export default Master_Dashboard